import { TimelineModel } from '../../../shared/models/timeline.model';
import { SignupFormKey } from '../login.model';
import { UserAlias } from '../../../shared/constants';
import { DocumentTypeModel, KYCDocumentType, KYCV2DocumentTypes } from '../kyc.model';
import { AddressGeolocation, CurrentLocation } from '@mpt-fo/common/kamona/model/kamonal-model';

export enum KycDictionary {
    Oops = 'Oops!',
    Go_Back = 'Go Back',
    Not_permitted_business_name = 'is not permitted in your business name',
    Login = 'Login',
    Dashboard = 'Dashboard',
    info = 'info',
    supply_info = 'Supply More Information',
    Account_created = 'Account created',
    New_Business_Owner_Account = 'New Business Owner Account',
    Please_Select_an_option = 'Please Select an option',
    INCORPORATED_COMPANY_PRIVATE_B = 'Incorporated Company',
    INCORPORATED_COMPANY_PRIVATE_A = 'Incorporated Company',
    INCORPORATED_TRUSTEES = 'Incorporated Trustees',
    BUSINESS_NAME = 'Business Name Registration',
    CONTINUE_UPGRADE = 'Continue Upgrade',
    CONTINUE = 'Continue',
    FIX_NOW = 'Fix Now',
    GET_STARTED = 'Get Started',
    certificateOfBusinessName = 'Certificate of BusinessName',
    certificateOfIncorporation = 'Certificate of Incorporation',
    certifiedApplicationForm = 'Certified ApplicationForm',
    boardResolution = 'Board Resolution',
    businessOwnerDocument = 'Business Owner Document',
    companyLetterOfAuthorization = 'Company Letter of Authorization',
    cooperativeCertificate = 'Cooperative Certificate',
    governmentApprovalDocument = 'Government Approval Document',
    memat = 'Memat',
    operatingLicense = 'Operating License',
    statementOfShareCapital = 'Statement of Share Capital',
    cac2 = 'Cac2',
    cac3 = 'Cac3',
    cac7 = 'Cac7',
    cacIt = 'CacIt',
    businessNumber = 'CAC Number',
    Level_1 = 'Level 1',
    Level_2 = 'Level 2',
    Level_3 = 'Level 3',
    Level_4 = 'Level 4',
    Level_5 = 'Level 5',
    Verification_in_Progress = 'Verification in Progress',
    Verification_in_Review = 'Verification in Review',
    Verification_Successful = 'Verification Successful',
    Bank_Verification_Number = 'Bank Verification Number (BVN)',
    National_Identity_Number = 'National Identity Number(NIN)',
    Level_1_Upgrade = 'Level 1 Upgrade',
    Level_2_Upgrade = 'Level 2 Upgrade',
    Level_3_Upgrade = 'Level 3 Upgrade',
    Level_4_Upgrade = 'Level 4 Upgrade',
    Provide_more_info = 'Provide More Info',
    Upgrade_Business_Owners_Account_to_Level_1 = 'Upgrade Business Owners Account to Level 1',
    Upgrade_Business_Owners_Account_to_Level_2 = 'Upgrade Business Owners Account to Level 2',
    Upgrade_Business_Owners_Account_to_Level_3 = 'Upgrade Business Owners Account to Level 3',
    Upgrade_Business_Owners_Account_to_Level_4 = 'Upgrade Business Owners Account to Level 4',
    Meta_Map_Verification = 'Meta Map Verification',
    MetaMap_Verification_In_Review = 'MetaMap Verification In Review',
    signup_identity_verification_pending = 'signup_identity_verification_pending',
    signup_identity_verification_initiated = 'signup_identity_verification_initiated',
    unable_to_verify_identity = 'We have not been able to verify your identity',
    liveliness_verification_failed = 'Liveliness failed',
    unable_to_verify_Bvn = 'We have not been able to verify Bvn',
    Identity_Verified = 'Identity Verified',
    verified_successfully = 'Your identification has been verified successfully.',
    Request_Error = 'Request Error',
    Request_Warning = 'Request Warning',
    error_occurred = 'An Error Occurred. Please try again',
    business_owner = 'Business Owners',
    customer_account_activation_with_bo_title = 'Customer Account Activation Required',
    customer_account_activation_with_bo_subtitle = 'Inform the customer to take the following steps to complete his Account Activation',
    customer_account_activation_without_bo_title = 'Activate Your Account',
    customer_account_activation_without_bo_subtitle = 'Complete the following steps to Activate Your Account',
    terminal_page_title = 'Account Has Been Upgraded But is Pending Activation',
    Activate_Account = 'Activate Account',
    Account_activation = 'Account Activation',
    sign_up_moniepoint = 'Sign Up to Moniepoint',
    profile_created = 'Moniepoint account created successfully',
    conclude_account_opening = 'Conclude Account Opening',
    go_to_dashboard = 'Go To Dashboard',
    summary = 'Summary',
    review_info = 'Review the following information',
    soft_onboarding_web_title = 'Setup Moniepoint Business Banking',
    address_not_found = 'No address found for user',
    unknown_result_code = 'Unrecognized result code',
    OKHI_NO_LGA_PROVIDED = 'No LGA provided from OKHI address',
    LOCATION_ACCURACY_THRESHOLD_EXCEEDED = 'Location accuracy threshold exceeded',
    LOCATION_ACCESS_DENIED = 'Location access denied',
}

export interface OnboardingFormData {
    username: string;
    deviceType: string;
    deviceUniqueIdentifier: string;
    emailAddress: string;
    manufacturer: string;
    model: string;
    password: string;
    validationKey: string;
}

export interface FormState {
    getKey();
    getRoute();
    getPreviousRoute();
    setState(state): void;
    updateTimeline(timeline: TimelineModel): void;
    getTimeline(): TimelineModel;
}

export const DefaultKycData: any = {
    businessKycInformation: {
        businessCategory: {},
        businessSubCategory: {},
        localGovernment: {},
        state: {},
    },
    personalInformation: {
        lgaOfOrigin: {},
        localGovernment: {},
        nationality: {},
    },
    bvnIdentityVerificationStatus: '',
    nextOfKinInformation: {},
    has_completed_business_address: false,
    has_completed_business_information: false,
    has_completed_liveliness_verification: false,
    has_completed_personal_information: false,
    has_completed_next_of_kin_information: false,
    has_uploaded_signature_file: false,
    has_completed_identity_verification: false,
    has_proof_of_address: false,
    has_business_pin: false,
    has_concluded_onboarding: false,
    customerFirstName: '',
    customerLastName: '',
    has_completed_contact_details: false,
    has_business_proof_of_address: false,
    has_completed_indemnity: false,
    has_completed_bvn: false,
    kycLevelTransactionLimit: {
        kycLevelOneTransactionLimit: {},
        kycLevelTwoTransactionLimit: {},
        kycLevelThreeTransactionLimit: {},
        kycLevelFourTransactionLimit: {},
        kycLevelFiveTransactionLimit: {},
    },
};

export const DefaultOnboardingData: OnboardingFormData = {
    username: '',
    deviceType: 'WEB',
    deviceUniqueIdentifier: null,
    emailAddress: null,
    manufacturer: null,
    model: null,
    password: null,
    validationKey: null,
};

export const MobileHeader = 27;
export const MobileAppHeader = 55;

export const SignupContentHeight = 'calc(100vh - 232px)';

export const SignupMobileContentHeight = 'calc(100vh - 287px)';

export const SignupFormSteps: TimelineModel[] = [
    {
        step: 1,
        key: SignupFormKey.PHONE_VERIFICATION,
        state: 'active',
        previousTitle: 'Setup Your Profile',
        title: 'Enter your Contact Details',
        description: 'Enter your contact details to get started',
    },
    {
        step: 2,
        state: 'inactive',
        key: SignupFormKey.OTP_VALIDATION,
        previousTitle: 'Setup Your Profile',
        title: 'Verify your Phone Number',
        description: 'We’ve just sent you a 6 digit code. ' + 'Check your messages and enter it here.',
    },
    {
        step: 3,
        state: 'inactive',
        key: SignupFormKey.BVN_VERIFICATION,
        previousTitle: 'Setup Your Profile',
        title: 'Enter your BVN',
        description: 'Enter your 11 Digit BVN',
    },
    {
        step: 4,
        state: 'inactive',
        key: SignupFormKey.CREATE_PROFILE,
        previousTitle: 'Setup Your Profile',
        title: 'Create your Profile',
        description: 'Select your Username & Password',
    },
    {
        step: 5,
        state: 'inactive',
        key: SignupFormKey.CREATE_PROFILE,
        previousTitle: 'Setup Your Profile',
        title: 'Create your Profile',
        description: 'Select your Username & Password',
    },
];

export const SignupV3FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: SignupFormKey.PHONE_VERIFICATION,
        state: 'active',
        previousTitle: '',
        title: 'Setup Your Profile',
        description: 'Just enter your phone number to get started',
    },
    {
        step: 2,
        state: 'inactive',
        key: SignupFormKey.OTP_VALIDATION,
        previousTitle: 'Setup Your Profile',
        title: 'Verify your Phone Number',
        description: 'We’ve just sent you a 6 digit code. ' + 'Check your messages and enter it here.',
    },
    {
        step: 3,
        state: 'inactive',
        key: SignupFormKey.BVN_VERIFICATION,
        previousTitle: 'Setup Your Profile',
        title: 'Enter your BVN',
        description: 'Enter your 11 Digit BVN',
    },
    {
        step: 4,
        state: 'inactive',
        key: SignupFormKey.ENTER_EMAIL,
        previousTitle: '',
        title: 'What’s Your Email Address',
        description: 'Enter your email address.',
    },
    {
        step: 5,
        state: 'inactive',
        key: SignupFormKey.CREATE_PASSCODE,
        previousTitle: '',
        title: 'Set Up Your Passcode',
        description: 'Enter a 6 digit passcode',
    },
];

export const SoftOnboardingSteps: TimelineModel[] = [
    {
        step: 1,
        key: '',
        state: 'active',
        previousTitle: 'Setup Your Profile',
        title: 'Contact Details',
        description: 'Confirm your contact details',
    },
    {
        step: 2,
        state: 'inactive',
        key: '',
        previousTitle: 'Setup Your Profile',
        title: 'Business Details',
        description: 'Provide details of your business',
    },
    {
        step: 3,
        state: 'inactive',
        key: '',
        previousTitle: 'Setup Your Profile',
        title: 'Business Address',
        description: 'Provide business address information',
    },
    {
        step: 4,
        state: 'inactive',
        key: '',
        previousTitle: 'Setup Your Profile',
        title: 'Summary',
        description: 'Create your account using these details',
    },
    {
        step: 5,
        state: 'inactive',
        key: '',
        previousTitle: 'Update Information',
        title: 'Edit Contact Details',
        description: 'Make changes to the contact information for your personal account',
    },
    {
        step: 6,
        state: 'inactive',
        key: '',
        previousTitle: 'Update Information',
        title: 'Verify Your Phone Number',
        description: 'We’ve just sent you a 6 digit code. Check your messages and enter it here',
    },
];

export const SignupFormPlaceholder = '$####';

export const SignupFormStepsV2: TimelineModel[] = [
    {
        step: 1,
        key: SignupFormKey.PHONE_VERIFICATION,
        state: 'active',
        previousTitle: 'Setup Your Profile',
        title: 'Create your account',
        description: 'Enter your details to get started',
    },
    {
        step: 2,
        state: 'inactive',
        key: SignupFormKey.OTP_VALIDATION,
        previousTitle: 'Setup Your Profile',
        title: 'Verify your Phone Number',
        description: `We’ve just sent a 6 digit code to ${SignupFormPlaceholder}
		Check your messages and enter it here. `,
    },
    {
        step: 3,
        state: 'inactive',
        key: SignupFormKey.BVN_VERIFICATION,
        previousTitle: 'Setup Your Profile',
        title: 'Enter your BVN',
        description: `We’ve just sent a 6 digit code to ${SignupFormPlaceholder}
		Check your messages and enter it here. `,
    },
    {
        step: 4,
        state: 'inactive',
        key: SignupFormKey.CREATE_PROFILE,
        previousTitle: 'Setup Your Profile',
        title: 'Almost there',
        description: 'Choose a username, and password.',
    },
];

export function getNavigationAnimationClass(currentStep: number, previousStep = 1): string {
    if (previousStep === currentStep) {
        return 'animate__animated animate__slideInLeft';
    }
    return currentStep > previousStep ? 'animate__animated animate__slideInLeft' : 'animate__animated animate__slideInRight';
}

function getTimelineState(step: number, currentStep: number, currentState: string): any {
    let newState = step > currentStep ? 'inactive' : currentState;
    newState = step < currentStep ? 'completed' : newState;
    return newState;
}

export function processTimelineSteps(formSteps: TimelineModel[], currentStep: number, skippedStep = -1): TimelineModel[] {
    formSteps.forEach((step) => {
        const stepStep = step?.step;
        let stepState: any = stepStep === currentStep ? 'active' : 'inactive';
        stepState = getTimelineState(stepStep, currentStep, stepState);
        stepState = stepStep === skippedStep ? 'processing' : stepState;
        step.state = stepState;
    });
    return formSteps;
}

export const TotalSignupStep = 4;

export const TotalSignupV3Step = 5;

export enum SignupFormStep {
    CONTACT_DETAILS = 1,
    PHONE_VERIFICATION,
    BVN_VERIFICATION,
    PROFILE_CREATION,
    PROFILE_CREATION_AFTER_NIBSS_VERIFICATION,
}

export enum LoginV2FormStep {
    LOGIN = 1,
    PASSWORD,
    PASSCODE,
}

export enum SignupV3FormStep {
    CONTACT_DETAILS = 1,
    PHONE_VERIFICATION,
    BVN_VERIFICATION,
    EMAIL,
    PASSCODE,
}

export const TotalSoftOnboardingStep = 4;

export enum SoftOnboardingStep {
    CONTACT_DETAILS = 1,
    BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    SUMMARY,
    EDIT_CONTACT_DETAILS,
    PHONE_VERIFICATION,
}

export enum KYCLevel {
    LVL_0,
    LVL_1 = 1,
    LVL_2,
    LVL_3,
    LVL_4,
    LVL_5,
}

export enum KYCLevelStatusV2 {
    'kycLevelOneStatus' = 'kycLevelOneStatus',
    'kycLevelTwoStatus' = 'kycLevelTwoStatus',
    'kycLevelThreeStatus' = 'kycLevelThreeStatus',
    'kycLevelFourStatus' = 'kycLevelFourStatus',
    'kycLevelFiveStatus' = 'kycLevelFiveStatus',
}

export enum KYCLevelV2 {
    'kycLevelOneStatus' = KYCLevel.LVL_1,
    'kycLevelTwoStatus' = KYCLevel.LVL_2,
    'kycLevelThreeStatus' = KYCLevel.LVL_3,
    'kycLevelFourStatus' = KYCLevel.LVL_4,
    'kycLevelFiveStatus' = KYCLevel.LVL_5,
}

export const KYCLevelV3 = [
    { id: 'kycLevelOneStatus', value: KYCLevel.LVL_1 },
    { id: 'kycLevelTwoStatus', value: KYCLevel.LVL_2 },
    { id: 'kycLevelThreeStatus', value: KYCLevel.LVL_3 },
    { id: 'kycLevelFourStatus', value: KYCLevel.LVL_4 },
    { id: 'kycLevelFiveStatus', value: KYCLevel.LVL_5 },
];

export const KycLevelTransactionLimitKeys = [
    { lvl: KYCLevel.LVL_1, key: 'kycLevelOneTransactionLimit' },
    { lvl: KYCLevel.LVL_2, key: 'kycLevelTwoTransactionLimit' },
    { lvl: KYCLevel.LVL_3, key: 'kycLevelThreeTransactionLimit' },
    { lvl: KYCLevel.LVL_4, key: 'kycLevelFourTransactionLimit' },
    { lvl: KYCLevel.LVL_5, key: 'kycLevelFiveTransactionLimit' },
];

export const KycGroupPrimerControls = [
    { lvl: KYCLevel.LVL_1, isToggled: false },
    { lvl: KYCLevel.LVL_2, isToggled: false },
    { lvl: KYCLevel.LVL_3, isToggled: false },
    { lvl: KYCLevel.LVL_4, isToggled: false },
    { lvl: KYCLevel.LVL_5, isToggled: false },
];

export type KycLevel1Steps =
    | typeof KYCLvl1StepV7
    | typeof KYCLvl1StepV6
    | typeof KYCLvl1StepV5
    | typeof KYCLvl1StepV4
    | typeof KYCLvl1StepV3
    | typeof KYCLvl1StepV2
    | typeof KYCLvl1Step;

export enum KYCLvl1Step {
    FACE_VERIFICATION = 1,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    ATTESTATION,
}

export enum KycLvl1FormStep {
    BVN_VERIFICATION = 'BVN_VERIFICATION',
    FACE_VERIFICATION = 'FACE_VERIFICATION',
    RESIDENTIAL_ADDRESS = 'RESIDENTIAL_ADDRESS',
    BUSINESS_INFORMATION = 'BUSINESS_INFORMATION ',
    BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
    ATTESTATION = 'ATTESTATION',
}

export enum KYCLvl1StepV2 {
    BVN_VERIFICATION = 1,
    FACE_VERIFICATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    ATTESTATION,
}

export enum KYCLvl1StepV3 {
    BVN_NIN_VERIFIED = 1,
    FACE_VERIFICATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    ATTESTATION,
}

export enum KYCLvl1StepV4 {
    NATIONALITY = 1,
    BVN_NIN_VERIFIED,
    FACE_VERIFICATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum KYCLvl1StepV5 {
    BVN_NIN_VERIFIED = 1,
    FACE_VERIFICATION,
    NATIONALITY,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum KYCLvl1StepV6 {
    BVN_NIN_VERIFIED = 1,
    FACE_VERIFICATION,
    NATIONALITY,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum KYCLvl1StepV7 {
    BVN_NIN_VERIFIED = 1,
    FACE_VERIFICATION,
    NATIONALITY,
    RESIDENTIAL_ADDRESS,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum KYCLvl2Step {
    NEXT_OF_KIN = 1,
    ID_VERIFICATION,
    PROOF_OF_ADDRESS,
    PROOF_OF_BUSINESS_ADDRESS,
}

export enum KYCLvl2StepV2 {
    IDENTITY_SELECTED = 1,
    NEXT_OF_KIN,
    ID_VERIFICATION,
    PROOF_OF_ADDRESS,
    PROOF_OF_BUSINESS_ADDRESS,
}

export enum KYCLvl2StepV3 {
    IDENTITY_SELECTED = 1,
    NEXT_OF_KIN,
}

export enum KYCLvl3StepV3 {
    FACE_VERIFICATION = 'FACE_VERIFICATION',
    ADDRESS_COLLECTION = 'ADDRESS_COLLECTION',
    PROOF_OF_ADDRESS_VERIFICATION = 'PROOF_OF_ADDRESS_VERIFICATION',
    RESIDENTIAL_PHYSICAL_ADDRESS_VERIFICATION = 'RESIDENTIAL_PHYSICAL_ADDRESS_VERIFICATION',
    INDEMNITY = 'INDEMNITY',
}

export enum KYCLvl3StepV3EventNames {
    FACE_VERIFICATION = 'face_verification_status',
    ADDRESS_COLLECTION = 'address_collection_status',
    PROOF_OF_ADDRESS_VERIFICATION = 'PoF_address_status',
    RESIDENTIAL_PHYSICAL_ADDRESS_VERIFICATION = 'address_verification_status',
    INDEMNITY = 'indemnity_status',
}

export interface KycLvl3LogMixpanelOptions {
    event: string;
    params?: { [key: string]: string | number | boolean };
    kycStandingSteps?: KYCLvl3StepV3[];
}

export interface KycLvl3EventParams {
  api_error_message?: string;
  api_error_code?: number;
  old_meter_provider?: string;
  new_meter_provider?: string;
  doc_type?: string;
  meterProvider?: string;
  [key: string]: string | number | boolean ;
}

export enum KYCLvl3Step {
    PROOF_OF_ADDRESS_VERIFICATION = 1,
    INDEMNITY,
}

export enum KYCLvl4Step {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KYCLvl4StepV2 {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KYCLvl4StepV3 {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KYCLvl4StepV4 {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export const KYCLevelRoutes = [
    { level: KYCLevel.LVL_1, route: '/onboarding-v2/kyc-lvl1', brmRoute: '/onboarding-v2/brm-kyc-lvl1' },
    { level: KYCLevel.LVL_2, route: '/onboarding-v2/kyc-lvl2', brmRoute: '/onboarding-v2/brm-kyc-lvl2' },
    { level: KYCLevel.LVL_3, route: '/onboarding-v2/kyc-lvl3', brmRoute: '/onboarding-v2/brm-kyc-lvl3' },
    { level: KYCLevel.LVL_4, route: '/onboarding-v2/kyc-lvl4', brmRoute: '/onboarding-v2/brm-kyc-lvl4' },
    { level: KYCLevel.LVL_5, route: '/onboarding-v2/kyc-lvl5', brmRoute: '/onboarding-v2/brm-kyc-lvl5' },
];

export const KYCPrimerRoutes = [
    { level: KYCLevel.LVL_1, route: '/onboarding-v2/kyc-lvl1-primer' },
    { level: KYCLevel.LVL_2, route: '/onboarding-v2/kyc-lvl2-primer' },
    { level: KYCLevel.LVL_3, route: '/onboarding-v2/kyc-lvl3-primer' },
    { level: KYCLevel.LVL_4, route: '/onboarding-v2/kyc-lvl4-primer' },
    { level: KYCLevel.LVL_5, route: '/onboarding-v2/kyc-lvl5-primer' },
];

export enum KYCFormKeys {
    PERSONAL_INFORMATION = 'has_completed_personal_information',
    FACE_VERIFICATION = 'has_completed_face_verification',
    NEXT_OF_KIN = 'has_completed_next_of_kin_information',
    PROOF_OF_ADDRESS = 'has_proof_of_address',
    PROOF_OF_ADDRESS_VERIFICATION = 'has_completed_proof_of_address_verification',
    RESIDENTIAL_ADDRESS = 'has_completed_residential_address',
    IDENTITY_VERIFICATION = 'has_completed_identity_verification',
    BVN_NIN_VERIFIED = 'has_verified_bvn_or_nin',
    BUSINESS_TYPE = 'has_completed_business_type',
    INDEMNITY = 'has_completed_indemnity',
    BUSINESS_INFORMATION = 'has_completed_business_information',
    ADDITIONAL_BUSINESS_DETAILS = 'additionalBusinessInformation.hasSubmittedAdditionalBusinessInfo',
    BUSINESS_ADDRESS = 'has_completed_business_address',
    TRANSACTION_PIN = 'has_business_pin',
    BUSINESS_PROOF_OF_ADDRESS = 'has_business_proof_of_address',
    CAC_NUMBER = 'has_completed_cac_number',
    CONTACT_DETAILS = 'has_completed_contact_details',
    BUSINESS_NAME = 'has_business_name',
    CERTIFICATED_FORM = 'has_certificate_form',
    SIGNATURE_UPLOAD = 'has_uploaded_signature_file',
    SUMMARY = 'has_finished_kyc',
    BVN_COMPLETED = 'has_completed_bvn',
    NIN_COMPLETED = 'has_completed_nin',
    IDENTITY_VERIFICATION_IN_REVIEW = 'identity_verification_in_review',
    LIVELINESS = 'has_completed_liveliness_verification',
    BUSINESS_DETAIL = 'has_completed_business_detail',
    TIN_DETAIL = 'hasVerifiedTin',
    AFFILIATE_DETAIL = 'has_completed_affiliate_detail',
    SCUML_DETAILS = 'SCUML',
    SUPPORTING_DOCUMENTS = 'has_completed_business_documentation',
    BUSINESS_NAME_CHANGE = 'has_reviewed_all_businesses',
    SUPPORTING_DOCUMENTS_SUMMARY = 'has_completed_supporting_documents_summary',
    bvnIdentityVerificationStatus = 'bvnIdentityVerificationStatus',
    ninIdentityVerificationStatus = 'ninIdentityVerificationStatus',
    providerLivelinessVerificationStatus = 'providerLivelinessVerificationStatus',
    providerIdentityVerificationStatus = 'providerIdentityVerificationStatus',
    PEP = 'pepInfoSubmitted',
    NATIONALITY = 'has_submitted_nationality',
    SOURCE_OF_WEALTH = 'has_submitted_source_of_wealth',
}

export const KycLevel1BvnOrNinTimeline: TimelineModel = {
    key: KYCFormKeys.BVN_NIN_VERIFIED,
    state: 'active',
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 1',
    mobileNote: 'Please select BVN or NIN',
    description: 'BVN or NIN',
    iconName: 'NIN',
    extraDescription: 'Provide either to open a Level 1 account. Both will be required for higher levels. ',
    required: true,
};

const LivelinessTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.LIVELINESS,
    previousTitle: KycDictionary.Level_1_Upgrade,
    required: true,
    mobileNote: 'Provide the information below',
    description: 'ID Verification',
};

const FaceVerificationTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.FACE_VERIFICATION,
    previousTitle: KycDictionary.Level_1_Upgrade,
    required: true,
    mobileNote: 'Provide the information below',
    description: 'Face Verification',
    iconName: 'faceVerification',
};

export const NationalityTimeline: TimelineModel = {
    key: KYCFormKeys.NATIONALITY,
    state: 'inactive',
    previousTitle: KycDictionary.Level_1_Upgrade,
    mobileNote: 'Select the country you are from',
    description: 'Nationality',
    iconName: 'businessInformation',
    required: true,
};

const ContactDetailsTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.CONTACT_DETAILS,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 3',
    required: true,
    mobileNote: 'Please provide the required information',
    description: 'Contact Information',
};

const PersonalInformationTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.PERSONAL_INFORMATION,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 4',
    required: true,
    mobileNote: 'Please provide the following information.',
    description: 'Residential Address',
    iconName: 'location',
};

const BusinessInformationTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.BUSINESS_INFORMATION,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 5',
    required: true,
    mobileNote: 'Please provide the following information.',
    description: 'Business Details',
    iconName: 'businessInformation',
};

const AdditionalBusinessDetailsTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.ADDITIONAL_BUSINESS_DETAILS,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step',
    required: true,
    mobileNote: 'Provide additional details of your business.',
    description: 'Additional Business Details',
    iconName: 'businessInformation',
};

const BusinessAddressTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.BUSINESS_ADDRESS,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 6',
    required: true,
    mobileNote: 'Please provide the following information.',
    description: 'Business Address',
    iconName: 'businessDetails',
};

const PEPStatusTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.PEP,
    previousTitle: KycDictionary.Level_1_Upgrade,
    title: 'Step 7',
    mobileNote: 'Provide details of your PEP status',
    description: 'PEP Status',
    iconName: 'location',
    required: true,
};

const SourceOfWealthTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.SOURCE_OF_WEALTH,
    previousTitle: KycDictionary.Level_1_Upgrade,
    mobileNote: 'Provide details of your source of revenue',
    description: 'Source of Revenue',
    iconName: 'businessInformation',
    required: true,
};

const AttestationTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.SIGNATURE_UPLOAD,
    previousTitle: KycDictionary.Level_1_Upgrade,
    required: true,
    mobileNote: 'Review the following information and attest',
    description: 'Attestation',
    iconName: 'sign',
};

const SignatureUploadTimeline: TimelineModel = {
    state: 'inactive',
    key: KYCFormKeys.SIGNATURE_UPLOAD,
    previousTitle: KycDictionary.Level_1_Upgrade,
    required: true,
    mobileNote: 'Please upload Signature File',
    description: 'Signature Upload',
};

export const KYCLvl1FormStepsV3: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        key: KYCFormKeys.FACE_VERIFICATION,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        mobileNote: 'Provide the information below',
        description: 'Face Verification',
        iconName: 'faceVerification',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
        iconName: 'location',
        required: true,
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        mobileNote: 'Please provide the following information',
        description: 'Business Details',
        iconName: 'businessInformation',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        mobileNote: 'Please provide the following information.',
        iconName: 'businessDetails',
        description: 'Business Address',
        required: true,
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        mobileNote: 'Review the following information and attest',
        iconName: 'sign',
        description: 'Attestation',
        required: true,
    },
];
const kycLvl1FormStepsV4: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.NATIONALITY,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        mobileNote: 'Select the country you are from',
        description: 'Nationality',
        iconName: 'businessInformation',
        required: true,
    },
    KycLevel1BvnOrNinTimeline,
    {
        step: 3,
        key: KYCFormKeys.FACE_VERIFICATION,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        mobileNote: 'Provide the information below',
        description: 'Face Verification',
        iconName: 'faceVerification',
        required: true,
    },

    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
        iconName: 'location',
        required: true,
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        mobileNote: 'Please provide the following information',
        description: 'Business Details',
        iconName: 'businessInformation',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        mobileNote: 'Please provide the following information.',
        iconName: 'businessDetails',
        description: 'Business Address',
        required: true,
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.PEP,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        mobileNote: 'Provide details of your PEP status',
        description: 'PEP Status',
        iconName: 'location',
        required: true,
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SOURCE_OF_WEALTH,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 8',
        mobileNote: 'Provide details of your source of revenue',
        description: 'Source of Revenue',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 9,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 9',
        mobileNote: 'Review the following information and attest',
        iconName: 'sign',
        description: 'Attestation',
        required: true,
    },
];

const generateTimeline = (timeline: TimelineModel[]) => {
    return timeline.map((timeline, index) => ({ ...timeline, step: index + 1, title: `Step ${index + 1}` }));
};

export const generateBranchBrmStep = (brmKycLvl1Steps: TimelineModel[]) => {
    [...brmKycLvl1Steps].splice(brmKycLvl1Steps.length - 1, 0, SignatureUploadTimeline);
    return brmKycLvl1Steps;
};

export const KYCLvl1FormStepsV4 = generateTimeline(kycLvl1FormStepsV4);

// KYCLvl1FormStepsV5 => Bvn before Nationality form step
const kycLvl1FormStepsV5: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        key: KYCFormKeys.FACE_VERIFICATION,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        mobileNote: 'Provide the information below',
        description: 'Face Verification',
        iconName: 'faceVerification',
        required: true,
    },
    {
        step: 3,
        key: KYCFormKeys.NATIONALITY,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        mobileNote: 'Select the country you are from',
        description: 'Nationality',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
        iconName: 'location',
        required: true,
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        mobileNote: 'Please provide the following information',
        description: 'Business Details',
        iconName: 'businessInformation',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        mobileNote: 'Please provide the following information.',
        iconName: 'businessDetails',
        description: 'Business Address',
        required: true,
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.PEP,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        mobileNote: 'Provide details of your PEP status',
        description: 'PEP Status',
        iconName: 'location',
        required: true,
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SOURCE_OF_WEALTH,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 8',
        mobileNote: 'Provide details of your source of revenue',
        description: 'Source of Revenue',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 9,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 9',
        mobileNote: 'Review the following information and attest',
        iconName: 'sign',
        description: 'Attestation',
        required: true,
    },
];

const kycLvl1FormStepsV6: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    FaceVerificationTimeline,
    NationalityTimeline,
    PersonalInformationTimeline,
    BusinessInformationTimeline,
    AdditionalBusinessDetailsTimeline,
    BusinessAddressTimeline,
    PEPStatusTimeline,
    SourceOfWealthTimeline,
    AttestationTimeline,
];

const kycLvl1FormStepsV7: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    FaceVerificationTimeline,
    NationalityTimeline,
    PersonalInformationTimeline,
    BusinessInformationTimeline,
    BusinessAddressTimeline,
    PEPStatusTimeline,
    SourceOfWealthTimeline,
    AttestationTimeline,
];

export const KYCLvl1FormStepsV5 = generateTimeline(kycLvl1FormStepsV5);
export const KYCLvl1FormStepsV6 = generateTimeline(kycLvl1FormStepsV6);
export const KYCLvl1FormStepsV7 = generateTimeline(kycLvl1FormStepsV7);
export const KYCLvl1FormStepsV2: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.BVN_COMPLETED,
        state: 'active',
        previousTitle: 'Level 1',
        title: 'Step 1',
        mobileNote: 'Enter your 11 Digit BVN',
        description: 'BVN Verification',
        iconName: 'BVN',
        required: true,
    },
    {
        step: 2,
        key: KYCFormKeys.FACE_VERIFICATION,
        state: 'inactive',
        previousTitle: 'Level 1',
        title: 'Step 2',
        mobileNote: 'Provide the information below',
        description: 'Face Verification',
        iconName: 'faceVerification',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: 'Level 1',
        title: 'Step 3',
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
        iconName: 'location',
        required: true,
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: 'Level 1',
        title: 'Step 4',
        mobileNote: 'Please provide the following information',
        description: 'Business Details',
        iconName: 'businessInformation',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: 'Level 1',
        title: 'Step 5',
        mobileNote: 'Please provide the following information.',
        iconName: 'businessDetails',
        description: 'Business Address',
        required: true,
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: 'Level 1',
        title: 'Step 6',
        mobileNote: 'Review the following information and attest',
        iconName: 'sign',
        description: 'Attestation',
        required: true,
    },
];

export enum KycLevelFlow {
    DEFAULT,
    NIN,
    ENHANCED,
}

export const KYCLvl1FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.FACE_VERIFICATION,
        state: 'active',
        previousTitle: 'Level 1',
        title: 'Step 1',
        mobileNote: 'Provide the information below',
        description: 'Face Verification',
        iconName: 'faceVerification',
        required: true,
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: 'Level 1',
        title: 'Step 2',
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
        iconName: 'location',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: 'Level 1',
        title: 'Step 3',
        mobileNote: 'Please provide the following information',
        description: 'Business Details',
        iconName: 'businessInformation',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: 'Level 1',
        title: 'Step 4',
        mobileNote: 'Please provide the following information.',
        iconName: 'businessDetails',
        description: 'Business Address',
        required: true,
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: 'Level 1',
        title: 'Step 5',
        mobileNote: 'Review the following information and attest',
        iconName: 'sign',
        description: 'Attestation',
        required: true,
    },
];

export const TotalLvl1Step = KYCLvl1FormSteps.length;
export const TotalLvl1StepV2 = KYCLvl1FormStepsV2.length;
export const TotalLvl1StepV3 = KYCLvl1FormStepsV4.length;

export interface BvnResponse {
    redirectUrl?: string;
    reference?: string;
    pendingKycRequestDto?: any;
    exists?: boolean;
}

export interface OtpResponse {
    validationKey?: string;
    useNewBvnProcess?: boolean;
    shouldUseNewBvnFlow?: boolean;
}
export const KYCLvl2FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.NEXT_OF_KIN,
        state: 'active',
        previousTitle: 'Level 2',
        title: 'Step 1',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.IDENTITY_VERIFICATION,
        previousTitle: 'Level 2',
        title: 'Step 2',
        mobileNote: 'Supply a government issued ID.',
        description: 'ID Verification',
        canBeRejected: true,
        iconName: 'idVerification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        previousTitle: 'Level 2',
        title: 'Step 3',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Residential)',
        iconName: 'location',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
        previousTitle: 'Level 2',
        title: 'Step 4',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Business)',
        iconName: 'location',
    },
];

export const TotalLvl2Step = KYCLvl2FormSteps.length;

export const KycLevel2NinTimeline: TimelineModel = {
    step: 1,
    key: KYCFormKeys.NIN_COMPLETED,
    state: 'active',
    previousTitle: 'Level 2',
    title: 'Step 1',
    mobileNote: 'Enter your 11 Digit NIN.',
    description: 'NIN',
    iconName: 'NIN',
};

export const KycLevel2BvnTimeline: TimelineModel = {
    step: 1,
    key: KYCFormKeys.BVN_COMPLETED,
    state: 'active',
    previousTitle: 'Level 2',
    title: 'Step 1',
    mobileNote: 'Enter your 11 Digit BVN.',
    description: 'BVN',
    iconName: 'NIN',
};
export const TotalKycLvl2StepsV2 = 5;
export const KYCLvl2FormStepsV2: TimelineModel[] = [
    KycLevel2NinTimeline,
    {
        step: 2,
        key: KYCFormKeys.NEXT_OF_KIN,
        state: 'inactive',
        previousTitle: 'Level 2',
        title: 'Step 2',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.IDENTITY_VERIFICATION,
        previousTitle: 'Level 2',
        title: 'Step 3',
        mobileNote: 'Supply a government issued ID.',
        description: 'ID Verification',
        canBeRejected: true,
        iconName: 'idVerification',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        previousTitle: 'Level 2',
        title: 'Step 4',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Residential)',
        iconName: 'location',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
        previousTitle: 'Level 2',
        title: 'Step 5',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Business)',
        iconName: 'location',
    },
];

export const KYCLvl2FormStepsV3: TimelineModel[] = [
    { ...KycLevel2NinTimeline },
    {
        step: 2,
        key: KYCFormKeys.NEXT_OF_KIN,
        state: 'inactive',
        previousTitle: 'Level 2',
        title: 'Step 2',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
];

export const TotalLvl2StepV2 = KYCLvl2FormStepsV2.length;
export const TotalLvl2StepV3 = KYCLvl2FormStepsV3.length;

export const KycIndemnity =
    '' +
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit magnis odio curabitur vitae. Et ultrices nunc, tellus leo mauris ipsum ac. Molestie gravida ipsum dignissim lacus id in sit. Lobortis ullamcorper dui mauris dui neque leo. Faucibus sed elit tortor pellentesque tincidunt ipsum. \n' +
    '\n' +
    'Mi odio amet metus faucibus nisl vestibulum cras amet sed. Elementum quam vel enim enim commodo, id curabitur vitae.\n' +
    'Enim turpis odio integer purus amet nec tortor at eget. Nec ac ornare tempor eget id cras dignissim nulla. \n' +
    '\n' +
    'Tellus sit tincidunt purus justo adipiscing. Pellentesque vel molestie risus, elementum. Quam lectus duis pellentesque dictumst posuere vitae. Ut lacus vitae, urna enim eu dictum nisl mauris. Sed ac varius blandit ridiculus. Orci viverra arcu vel arcu et a dui. Dolor et orci, elementum ut donec posuere placerat velit, et.\n' +
    '\n' +
    'Sodales sit ipsum pretium sem ipsum urna, eleifend risus. Aliquam in pharetra, mattis ullamcorper aliquet fringilla.' +
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit magnis odio curabitur vitae. Et ultrices nunc, tellus leo mauris ipsum ac. Molestie gravida ipsum dignissim lacus id in sit. Lobortis ullamcorper dui mauris dui neque leo. Faucibus sed elit tortor pellentesque tincidunt ipsum. \n' +
    '\n' +
    'Mi odio amet metus faucibus nisl vestibulum cras amet sed. Elementum quam vel enim enim commodo, id curabitur vitae.\n' +
    'Enim turpis odio integer purus amet nec tortor at eget. Nec ac ornare tempor eget id cras dignissim nulla. \n' +
    '\n' +
    'Tellus sit tincidunt purus justo adipiscing. Pellentesque vel molestie risus, elementum. Quam lectus duis pellentesque dictumst posuere vitae. Ut lacus vitae, urna enim eu dictum nisl mauris. Sed ac varius blandit ridiculus. Orci viverra arcu vel arcu et a dui. Dolor et orci, elementum ut donec posuere placerat velit, et.\n' +
    '\n' +
    'Sodales sit ipsum pretium sem ipsum urna, eleifend risus. Aliquam in pharetra, mattis ullamcorper aliquet fringilla.';

export const KYCLvl3FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.PROOF_OF_ADDRESS_VERIFICATION,
        state: 'active',
        previousTitle: 'Level 3',
        title: 'Step 1',
        canBeRejected: true,
        mobileNote: 'Proof of Address Verification',
        description: 'Proof of Address Verification',
        iconName: 'location',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.INDEMNITY,
        previousTitle: 'Level 3',
        title: 'Step 2',
        mobileNote: 'Please upload the required documentation.',
        description: 'Indemnity',
        iconName: 'sign',
    },
];

export const KYCLvl3FormStepsV3: TimelineModel[] = [
    {
        step: 1,
        key: KYCLvl3StepV3.FACE_VERIFICATION,
        state: 'active',
        title: 'Step 1',
        canBeRejected: true,
        mobileNote: "Verify customer's face",
        description: 'Face Verification',
        iconName: 'faceVerification',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCLvl3StepV3.ADDRESS_COLLECTION,
        previousTitle: 'Level 3',
        title: 'Step 2',
        mobileNote: 'Please provide the following information',
        description: 'Residential Address Collection',
        iconName: 'location',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCLvl3StepV3.PROOF_OF_ADDRESS_VERIFICATION,
        previousTitle: 'Level 3',
        title: 'Step 3',
        mobileNote: 'Please provide the following information.',
        description: 'Address Document Verification',
        iconName: 'location',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCLvl3StepV3.RESIDENTIAL_PHYSICAL_ADDRESS_VERIFICATION,
        previousTitle: 'Level 3',
        title: 'Step 4',
        mobileNote: 'Verify your address to complete your upgrade',
        description: 'Physical Address Verification',
        iconName: 'location',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCLvl3StepV3.INDEMNITY,
        previousTitle: 'Level 3',
        title: 'Step 5',
        mobileNote: 'Please approve to continue.',
        description: 'Indemnity',
        iconName: 'sign',
    },
];

export const KYCLvl3PhysicalAddressTimelines: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        state: 'active',
        previousTitle: 'Level 3',
        title: 'Step 1',
        canBeRejected: true,
        mobileNote: 'Proof of Residential Address',
        description: 'Proof of Residential Address',
        iconName: 'location',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.INDEMNITY,
        previousTitle: 'Level 3',
        title: 'Step 2',
        mobileNote: 'Please upload the required documentation.',
        description: 'Indemnity',
        iconName: 'sign',
    },
];

export const TotalLvl3Step = KYCLvl3FormSteps.length;
export const TotalLvl3StepV3 = KYCLvl3FormStepsV3.length;

export enum Index {
    ZERO = 0,
    ONE,
    TWO,
    THREE,
    FOUR,
    FIVE,
}

export const FailedBusinessDetailsTimeline: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.BUSINESS_DETAIL,
        state: 'active',
        previousTitle: 'Dashboard',
        title: 'Step 1',
        canBeRejected: true,
        description: 'CAC Number',
        mobileNote: 'Enter your business details',
        iconName: 'supportingDocuments',
    },
];

export const FailedSupportingDocumentTimeline: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.SUPPORTING_DOCUMENTS,
        state: 'active',
        previousTitle: 'Dashboard',
        title: 'Step 1',
        canBeRejected: true,
        description: 'Supporting Documents',
        mobileNote: 'Enter your business details',
        iconName: 'supportingDocuments',
    },
];

export const KYCLvl4FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.BUSINESS_DETAIL,
        state: 'active',
        previousTitle: 'Level 4',
        title: 'Step 1',
        description: 'Business Details',
        mobileNote: 'Enter your business details',
        iconName: 'businessDetailslvl4',
        required: true,
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.SUPPORTING_DOCUMENTS,
        previousTitle: 'Level 4',
        title: 'Step 2',
        canBeRejected: true,
        description: 'Supporting Documents',
        mobileNote: 'Please provide the information below',
        iconName: 'supportingDocuments',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.SUPPORTING_DOCUMENTS_SUMMARY,
        previousTitle: 'Level 4',
        title: 'Step 3',
        disabled: true,
        description: 'Summary',
        mobileNote: 'Review the following information',
        iconName: 'sign',
        required: true,
    },
];

export enum TimelineIconName {
    tin = 'tin',
    supportingDocuments = 'supportingDocuments',
    scumlCertificate = 'scumlCertificate',
    sign = 'sign',
    idVerification = 'idVerification',
    location = 'location',
    businessDetailslvl4 = 'businessDetailslvl4',
}

export const BusinessAffiliateKeys = [KYCFormKeys.TIN_DETAIL, KYCFormKeys.AFFILIATE_DETAIL, KYCFormKeys.SCUML_DETAILS];

export const KycLevel4Timelines: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.BUSINESS_DETAIL,
        state: 'inactive',
        previousTitle: 'Level 4',
        title: 'Step 1',
        description: 'Business Details',
        mobileNote: 'Enter your business details',
        iconName: 'businessDetailslvl4',
        required: true,
    },
    {
        step: 2,
        key: KYCFormKeys.TIN_DETAIL,
        state: 'inactive',
        previousTitle: 'Level 4',
        title: 'Step 2',
        description: 'TIN Details',
        mobileNote: 'Enter your TIN details',
        iconName: 'tin',
        required: true,
    },
    {
        step: 3,
        key: KYCFormKeys.AFFILIATE_DETAIL,
        state: 'inactive',
        previousTitle: 'Level 4',
        title: 'Step 3',
        description: 'Affiliate Details',
        mobileNote: 'Enter your Affiliate Details',
        iconName: 'supportingDocuments',
        required: true,
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.SUPPORTING_DOCUMENTS,
        previousTitle: 'Level 4',
        title: 'Step 4',
        canBeRejected: true,
        description: 'Supporting Documents',
        mobileNote: 'Please provide the information below',
        iconName: 'supportingDocuments',
        required: true,
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.SCUML_DETAILS,
        previousTitle: 'Level 4',
        title: 'Step 5',
        canBeRejected: true,
        description: 'SCUML Details',
        mobileNote: 'Please provide the information below',
        iconName: 'scumlCertificate',
    },
    {
        step: 6,
        key: KYCFormKeys.BUSINESS_NAME_CHANGE,
        state: 'inactive',
        previousTitle: 'Level 4',
        title: 'Step 6',
        description: 'Business Names',
        mobileNote: 'Review your Business and account names',
        iconName: 'sign',
        required: true,
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SUPPORTING_DOCUMENTS_SUMMARY,
        previousTitle: 'Level 4',
        title: 'Step 7',
        disabled: true,
        description: 'Summary',
        mobileNote: 'Review the following information',
        iconName: 'sign',
        required: true,
    },
];

export const KYCLvl5FormSteps: TimelineModel[] = [
    {
        step: 1,
        key: KYCFormKeys.CAC_NUMBER,
        state: 'active',
        previousTitle: 'Level 5',
        title: 'Step 1',
        canBeRejected: true,
        mobileNote: '',
        description: 'CAC Number',
        iconName: 'supportingDocuments',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.SUPPORTING_DOCUMENTS,
        previousTitle: 'Level 5',
        title: 'Step 3',
        description: 'Supporting Document',
        mobileNote: '',
        iconName: 'supportingDocuments',
    },
];

export const BusinessCategoriesMap = new Map([
    ['agriculture', 'agriculture'],
    ['beauty and personal care', 'beautypersonalcare'],
    ['arts & creatives', 'artscreatives'],
    ['beauty & personal care', 'beautypersonalcare'],
    ['betting & lottery', 'bettinglottery'],
    ['charities & membership', 'charitiesmembership'],
    ['construction', 'construction'],
    ['education', 'education'],
    ['electronics', 'electronics'],
    ['events & entertainment', 'eventsentertainment'],
    ['fashion', 'fashion'],
    ['fashion and beauty', 'fashion'],
    ['food & drinks', 'foodanddrinks'],
    ['food and drinks', 'foodanddrinks'],
    ['betting and lottery', 'bettingandlottery'],
    ['fitness', 'fitness'],
    ['health care', 'healthcare'],
    ['home & repair', 'homerepair'],
    ['manufacturing', 'manufacturing'],
    ['oil & gas', 'oilandgas'],
    ['oil and gas', 'oilandgas'],
    ['pet care', 'petcare'],
    ['professional services', 'professional services'],
    ['retail & general trade', 'retailgeneraltrade'],
    ['religious institutions', 'religiousinstitutions'],
    ['transportation', 'transportation'],
    ['travel & leisure', 'travelleisure'],
]);

export const DocumentTypeMap = new Map([
    ['VOTERCARD', 'VOTER_CARD'],
    ['PASSPORT', 'PASSPORT'],
    ['NINCARD', 'NIN_CARD'],
    ['NINSLIP', 'NIN_SLIP'],
    ['DRIVERLICENCE', 'DRIVER_LICENCE'],
    ['CERTIFIEDAPPLICATIONFORM', 'CERTIFIED_APPLICATION_FORM'],
    ['CERTIFICATEOFBUSINESSNAME', 'CERTIFICATE_OF_BUSINESS_NAME'],
    ['CACIT', 'CAC_IT'],
    ['CAC2', 'CAC_2'],
    ['CAC3', 'CAC_3'],
    ['CAC7', 'CAC_7'],
    ['INCORPORATIONCETIFICATE', 'INCORPORATION_CETIFICATE'],
    ['BOARDRESOLUTION', 'BOARD_RESOLUTION'],
    ['SIGNATURE', 'SIGNATURE'],
    ['UTILITYBILL', 'UTILITY_BILL'],
    ['COMPANYLETTEROFAUTHORIZATION', 'COMPANY_LETTER_OF_AUTHORIZATION'],
    ['GOVERNMENTAPPROVALDOCUMENT', 'GOVERNMENT_APPROVAL_DOCUMENT'],
    ['BUSINESSOWNERDOCUMENTS', 'BUSINESS_OWNER_DOCUMENTS'],
    ['COOPERATIVECERTIFICATE', 'COOPERATIVE_CERTIFICATE'],
    ['OPERATINGLICENSE', 'OPERATING_LICENSE'],
    ['TCNOTICE', 'TC_NOTICE'],
    ['PARTICULARSOFDIRECTORS', 'PARTICULARS_OF_DIRECTORS'],
    ['CERTIFICATEOFREGISTRATION', 'CERTIFICATE_OF_REGISTRATION'],
    ['STATEMENTOFSHARECAPITAL', 'STATEMENT_OF_SHARE_CAPITAL'],
    ['BANKSTATEMENT', 'BANK_STATEMENT'],
    ['SOLICITORLETTER', 'SOLICITOR_LETTER'],
    ['TENANCYAGREEMENT', 'TENANCY_AGREEMENT'],
]);

export interface KycGauge {
    lvl: number;
    state: KycLvlState;
    disabled?: boolean;
}

export enum KycLvlState {
    COMPLETED = 'COMPLETED',
    STARTED = 'STARTED',
    REJECTED = 'REJECTED',
    NOT_STARTED = 'NOT_STARTED',
    SUBMITTED = 'SUBMITTED',
    FAILED = 'FAILED',
    SUCCESS = 'SUCCESS',
    PENDING = 'PENDING',
    APPROVED = 'APPROVED',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
}

export enum KycVerificationStatus {
    APPROVED = 'APPROVED',
    PENDING = 'PENDING',
    REJECTED = 'REJECTED',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
    NOT_DONE = 'NOT_DONE',
}

export const DefaultKycProgress: KycGauge[] = [
    { lvl: KYCLevel.LVL_1, state: KycLvlState.NOT_STARTED },
    { lvl: KYCLevel.LVL_2, state: KycLvlState.NOT_STARTED },
    { lvl: KYCLevel.LVL_3, state: KycLvlState.NOT_STARTED },
    { lvl: KYCLevel.LVL_4, state: KycLvlState.NOT_STARTED },
    { lvl: KYCLevel.LVL_5, state: KycLvlState.NOT_STARTED, disabled: true },
];

export enum KycDashboardBanner {
    UP_GRADE_REQUIRED,
    LVL_REVIEW_ONGOING,
    REVIEW_ONGOING,
    ACCOUNT_FIX_NEEDED,
    FIX_NEEDED,
}

export enum TimelineStatus {
    SUCCESS = 'SUCCESS',
    COMPLETED = 'COMPLETED',
    FAILED = 'FAILED',
    IN_REVIEW = 'IN_REVIEW',
    PENDING = 'PENDING',
    active = 'active',
    inactive = 'inactive',
    processing = 'processing',
    completed = 'completed',
    failed = 'failed',
    IN_PROGRESS = 'IN_PROGRESS',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
    APPROVED = 'APPROVED',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED',
    VERIFICATION_NOT_DONE = 'VERIFICATION_NOT_DONE',
    REJECTED_TERMINAL = 'REJECTED_TERMINAL',
    NOT_DONE = 'NOT_DONE',
}
export enum TimelineStatusV2 {
    FAILED = 'failed',
    SUCCESS = 'SUCCESS',
    COMPLETED = 'COMPLETED',
    IN_REVIEW = 'IN_REVIEW',
    PENDING = 'PENDING',
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    PROCESSING = 'processing',
    IN_PROGRESS = 'IN_PROGRESS',
    REVIEWING = 'REVIEWING',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
    APPROVED = 'APPROVED',
    VERIFIED = 'VERIFIED',
    REJECTED = 'REJECTED',
    EXPIRED = 'EXPIRED',
    ATTEMPTED = 'ATTEMPTED',
    CANCELLED = 'CANCELLED',
    VERIFICATION_NOT_DONE = 'VERIFICATION_NOT_DONE',
    REJECTED_TERMINAL = 'REJECTED_TERMINAL',
    NOT_DONE = 'NOT_DONE',
}

export enum FieldType {
    TEXT = 'text',
    RADIO = 'radio',
    FILE = 'file',
    DROPDOWN = 'dropdown',
    RADIO_DIRECTOR = 'radio_director',
    RADIO_PARTNER = 'radio_partner',
    BUTTON_PARTNER = 'button_partner',
    BUTTON_DIRECTOR = 'button_director',
}

export enum ConfirmType {
    Yes = 'Yes',
    No = 'No',
}

export enum KycBusinessType {
    BUSINESS_NAME = 'BUSINESS_NAME',
    INCORPORATED_TRUSTEES = 'INCORPORATED_TRUSTEES',
    INCORPORATED_COMPANY_PRIVATE_A = 'INCORPORATED_COMPANY_PRIVATE_A',
    INCORPORATED_COMPANY_PRIVATE_B = 'INCORPORATED_COMPANY_PRIVATE_B',
    INCORPORATED_COMPANY = 'INCORPORATED_COMPANY',
}

export enum KycBusinessTypeV2 {
    REGISTERED = 'REGISTERED',
    UNREGISTERED = 'UNREGISTERED',
}

export enum KycBusinessTypeDisplayName {
    BUSINESS_NAME = 'Business Name',
    INCORPORATED_TRUSTEES = 'Incorporated Trustees',
    INCORPORATED_COMPANY_PRIVATE_A = 'Incorporated Company',
    INCORPORATED_COMPANY_PRIVATE_B = 'Incorporated Company',
    INCORPORATED_COMPANY = 'Incorporated Company',
}

export enum IncorporatedCompany {
    PRIVATE_A = 'PRIVATE_A',
    PRIVATE_B = 'PRIVATE_B',
}

export const PRIVATELY_HELD_PRE_2017 = 'Privately Held (Pre-2017)';
export const PRIVATELY_HELD_2017_TO_DATE = 'Privately Held (2017 to date)';

export enum BusinessPrefix {
    BN = 'BN',
    IT = 'IT',
    RC = 'RC',
}

export enum BusinessQuestionnaireDropdown {
    ownershipStructure = 'ownershipStructure',
}

export interface BusinessQuestionnaire {
    businessType: string;
    fields: any[];
}

export enum AffiliateType {
    PARTNER = 'PARTNER',
    DIRECTOR = 'DIRECTOR',
    PROPRIETOR = 'PROPRIETOR',
}

export enum AffiliateDocumentType {
    address = 'address',
    identity = 'identity',
    signature = 'signature',
}

export const wordFilters = ['Enter', 'enter', 'Upload', 'upload'];

export enum KycBusinessDocumentDictionary {
    cac2 = 'Cac2',
    cac3 = 'Cac3',
    cac7 = 'Cac7',
    cacIt = 'CacIt',
    certificateOfBusinessName = 'Certificate of Business Name',
    certificateOfIncorporation = 'Certificate of Incorporation',
    certifiedApplicationForm = 'Certified Application Form',
    boardResolution = 'Board Resolution',
    memat = 'Memat',
}

export const MockSupportingDocStatus = {
    cac2: KycLvlState.PENDING,
    cac3: KycLvlState.PENDING,
    cac7: KycLvlState.PENDING,
    cacIt: KycLvlState.REJECTED,
    certificateOfBusinessName: KycLvlState.REJECTED,
    certificateOfIncorporation: KycLvlState.PENDING,
    certifiedApplicationForm: KycLvlState.PENDING,
    boardResolution: KycLvlState.PENDING,
    memat: KycLvlState.REJECTED,
};

export enum GracePeriodBannerUsage {
    DEFAULT,
    NIN,
    CAC,
}

export enum LivelinessEvent {
    liveness_initiated = 'liveness_initiated',
    liveness_completed = 'liveness_completed',
    liveness_succeeded = 'liveness_succeeded',
    liveness_failed = 'liveness_failed',
}

export enum ErrorCode {
    OTP_SUSPENSION = '400208',
    OTP_SUSPENSION_V2 = '400209',
    PROCESS_TOO_LONG = '40000',
    PROCESS_TOO_LONG_V2 = '400000',
    PROCESS_TOO_LONG_V3 = '400263',
    KYC_NOT_FOUND = '404000',
    LIVELINESS_IN_PROGRESS = '400239',
    LIVELINESS_IN_REVIEW = '400238',
    LIVELINESS_SUCCESSFUL = '400237',
    LIVELINESS_REQUIRED = '700006',
    IDENTITY_PROGRESS = '400236',
    IDENTITY_REVIEW = '400235',
    IDENTITY_SUCCESSFUL = '400234',
    BLACK_LISTED_BUSINESS_NAME = '400248',
    STAFF_USER_LOGIN = '700002',
    CLUSTER_MANAGER_USER_LOGIN = '70000211',
    ALL_BUSINESSES_CLOSED = '700101',
    PROFILE_FOUND = '400211',
    DEVICE_REGISTRATION = '403003',
    INVALID_BVN = '400068',
    INVALID_NIN = '400069',
    NO_BUSINESS_FOUND = '400061',
    CAC_SERVICE_UNAVAILABLE = '400062',
    BUSINESS_NAME_MISMATCH = '400064',
    NOT_BUSINESS_AFFILIATE = '400065',
    BUSINESS_TYPE_MISMATCH = '400063',
    CAC_ALREADY_EXIST = '400267',
    AFFILIATE_BLACKLISTED = '413002',
    VALIDATE_BVN_NIN_MISMATCH = '400270',
    TWO_FACTOR_AUTHENTICATION = '700066',
    EXTRA_LIVENESS_CHECK = '700067',
    EXTRA_LIVENESS_OTP_CHECK = '700068',
}

export enum MetaMapType {
    LIVELINESS = 'liveliness',
    IDENTITY = 'Identity',
}

export enum IdentityVerificationKeyType {
    LIVELINESS = KYCFormKeys.LIVELINESS,
    IDENTITY = KYCFormKeys.IDENTITY_VERIFICATION,
}

export enum BrmKycLvl1Steps {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    SIGNATURE,
    ATTESTATION,
}

export enum BrmKycLvl1StepsV2 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    ATTESTATION,
}

export enum BrmKycLvl1StepsV3 {
    BVN_VERIFICATION = 1,
    NATIONALITY,
    LIVELINESS,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum BranchBrmKycLvl1StepsV3 {
    BVN_VERIFICATION = 1,
    NATIONALITY,
    LIVELINESS,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    SIGNATURE,
    ATTESTATION,
}

export enum BrmKycLvl1StepsV4 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum BranchBrmKycLvl1StepsV4 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    SIGNATURE,
    ATTESTATION,
}

export enum BrmKycLvl1StepsV5 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum BranchBrmKycLvl1StepsV5 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    BUSINESS_INFORMATION,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    SIGNATURE,
    ATTESTATION,
}

export enum BrmKycLvl1StepsV6 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    ATTESTATION,
}

export enum BranchBrmKycLvl1StepsV6 {
    BVN_VERIFICATION = 1,
    LIVELINESS,
    NATIONALITY,
    CUSTOMER_INFORMATION,
    RESIDENTIAL_ADDRESS,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    PEP,
    SOURCE_OF_INCOME,
    SIGNATURE,
    ATTESTATION,
}

export type BrmKycLevel1Steps =
    | typeof BranchBrmKycLvl1StepsV3
    | typeof BrmKycLvl1Steps
    | typeof BrmKycLvl1StepsV3
    | typeof BrmKycLvl1StepsV2
    | typeof BranchBrmKycLvl1StepsV4
    | typeof BrmKycLvl1StepsV4
    | typeof BranchBrmKycLvl1StepsV5
    | typeof BrmKycLvl1StepsV5
    | typeof BranchBrmKycLvl1StepsV6
    | typeof BrmKycLvl1StepsV6;

export enum BrmKycLvl2Steps {
    NEXT_OF_KIN = 1,
    ID_VERIFICATION,
    PROOF_OF_ADDRESS,
    PROOF_OF_BUSINESS_ADDRESS,
    CUSTOMER_ACTIVATION,
}

export enum BrmKycLvl2StepsV2 {
    IDENTITY_SELECTED = 1,
    NEXT_OF_KIN,
    ID_VERIFICATION,
    PROOF_OF_ADDRESS,
    PROOF_OF_BUSINESS_ADDRESS,
    CUSTOMER_ACTIVATION,
}

export enum BrmKycLvl2StepsV3 {
    IDENTITY_SELECTED = 1,
    NEXT_OF_KIN,
    CUSTOMER_ACTIVATION,
}

export enum BrmKycLvl3Steps {
    PROOF_ADDRESS_VERIFICATION = 1,
    INDEMNITY,
}

export enum BrmKycLvl4Step {
    BUSINESS_DETAIL = 1,
    SUPPORTING_DOCUMENTS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export const TotalStepWOBO = 7;

export const TotalStepWBOKycLvl2 = 5;
export const TotalStepWOBOKycLvl2 = 4;
export const TotalStepKycLvl3 = 2;

export const BrmKycWBOLvl1Steps: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        key: KYCFormKeys.BVN_COMPLETED,
        required: true,
        mobileNote: 'Enter customer’s 11 Digit BVN',
        description: 'BVN Verification',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];
export const BrmKycWBOLvl1StepsV2: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];

const brmKycWBOLvl1StepsV3: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        key: KYCFormKeys.NATIONALITY,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        mobileNote: 'Select the country you are from',
        description: 'Nationality',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.PEP,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        mobileNote: 'Provide details of your PEP status',
        description: 'PEP Status',
        iconName: 'location',
        required: true,
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.SOURCE_OF_WEALTH,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 8',
        mobileNote: 'Provide details of your source of revenue',
        description: 'Source of Revenue',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];

const branchBrmKycWBOLvl1StepsV3: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        key: KYCFormKeys.NATIONALITY,
        state: 'inactive',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        mobileNote: 'Select the country you are from',
        description: 'Nationality',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.PEP,
        previousTitle: 'Level 1',
        title: 'Step 7',
        mobileNote: 'Provide details of your PEP status',
        description: 'PEP Status',
        iconName: 'location',
        required: true,
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.SOURCE_OF_WEALTH,
        previousTitle: 'Level 1',
        title: 'Step 8',
        mobileNote: 'Provide details of your source of revenue',
        description: 'Source of Revenue',
        iconName: 'businessInformation',
        required: true,
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Please upload Signature File',
        description: 'Signature Upload',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];

const brmKycWBOLvl1StepsV4: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    LivelinessTimeline,
    NationalityTimeline,
    ContactDetailsTimeline,
    PersonalInformationTimeline,
    BusinessInformationTimeline,
    BusinessAddressTimeline,
    PEPStatusTimeline,
    SourceOfWealthTimeline,
    AttestationTimeline,
];

const branchBrmKycWBOLvl1StepsV4: TimelineModel[] = generateBranchBrmStep(brmKycWBOLvl1StepsV4);

const brmKycWBOLvl1StepsV5: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    LivelinessTimeline,
    NationalityTimeline,
    ContactDetailsTimeline,
    PersonalInformationTimeline,
    BusinessInformationTimeline,
    AdditionalBusinessDetailsTimeline,
    BusinessAddressTimeline,
    PEPStatusTimeline,
    SourceOfWealthTimeline,
    AttestationTimeline,
];

const brmKycWBOLvl1StepsV6: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    LivelinessTimeline,
    NationalityTimeline,
    ContactDetailsTimeline,
    PersonalInformationTimeline,
    BusinessInformationTimeline,
    BusinessAddressTimeline,
    PEPStatusTimeline,
    SourceOfWealthTimeline,
    AttestationTimeline,
];

const branchBrmKycWBOLvl1StepsV5: TimelineModel[] = generateBranchBrmStep(brmKycWBOLvl1StepsV5);
const branchBrmKycWBOLvl1StepsV6: TimelineModel[] = generateBranchBrmStep(brmKycWBOLvl1StepsV6);
export const BrmKycWBOLvl1StepsV3 = generateTimeline(brmKycWBOLvl1StepsV3);

export const BranchBrmKycWBOLvl1StepsV3 = generateTimeline(branchBrmKycWBOLvl1StepsV3);
export const BrmKycWBOLvl1StepsV4 = generateTimeline(brmKycWBOLvl1StepsV4);
export const BranchBrmKycWBOLvl1StepsV4 = generateTimeline(branchBrmKycWBOLvl1StepsV4);
export const BrmKycWBOLvl1StepsV5 = generateTimeline(brmKycWBOLvl1StepsV5);
export const BranchBrmKycWBOLvl1StepsV5 = generateTimeline(branchBrmKycWBOLvl1StepsV5);
export const BrmKycWBOLvl1StepsV6 = generateTimeline(brmKycWBOLvl1StepsV6);
export const BranchBrmKycWBOLvl1StepsV6 = generateTimeline(branchBrmKycWBOLvl1StepsV6);

export const BrmKycWBOLvl1StepsBBRMV2: TimelineModel[] = [
    KycLevel1BvnOrNinTimeline,
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Please upload Signature File',
        description: 'Signature Upload',
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 8',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];
export const BrmKycWBOLvl1StepsBBRM: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        key: KYCFormKeys.BVN_COMPLETED,
        required: true,
        mobileNote: 'Enter customer’s 11 Digit BVN',
        description: 'BVN Verification',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.LIVELINESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'ID Verification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        required: true,
        mobileNote: 'Please upload Signature File',
        description: 'Signature Upload',
    },
    {
        step: 8,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1,
        title: 'Step 8',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];
export const TotalStepWBO = BrmKycWBOLvl1Steps.length;
export const TotalStepWBOV2 = BrmKycWBOLvl1StepsV3.length;
export const TotalStepWBOBBRM = BrmKycWBOLvl1StepsBBRM.length;
export const BrmKycWOBOLvl1Steps: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        key: KYCFormKeys.BVN_COMPLETED,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 1',
        required: true,
        mobileNote: 'Enter customer’s 11 Digit BVN',
        description: 'BVN Verification',
    },
    {
        step: 3,
        state: 'inactive',
        key: KYCFormKeys.CONTACT_DETAILS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 3',
        required: true,
        mobileNote: 'Please provide the required information',
        description: 'Contact Information',
    },
    {
        step: 4,
        state: 'inactive',
        key: KYCFormKeys.PERSONAL_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 4',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Residential Address',
    },
    {
        step: 5,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_INFORMATION,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 5',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Details',
    },
    {
        step: 6,
        state: 'inactive',
        key: KYCFormKeys.BUSINESS_ADDRESS,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 6',
        required: true,
        mobileNote: 'Please provide the following information.',
        description: 'Business Address',
    },
    {
        step: 7,
        state: 'inactive',
        key: KYCFormKeys.SIGNATURE_UPLOAD,
        previousTitle: KycDictionary.Level_1_Upgrade,
        title: 'Step 7',
        mobileNote: 'Please provide the following information',
        required: true,
        iconName: 'sign',
        description: 'Action Required',
    },
];

export const BrmKycWOBOLvl2Steps: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.NEXT_OF_KIN,
        title: 'Step 1',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
    {
        step: 3,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        title: 'Step 2',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Residential)',
        iconName: 'location',
    },
    {
        step: 4,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
        title: 'Step 3',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Business)',
        iconName: 'location',
    },
    {
        step: 5,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        title: 'Step 4',
        mobileNote: 'Please provide the following information',
        required: true,
        iconName: 'sign',
        description: 'Action Required',
    },
];

export const BrmKycWBOLvl2Steps: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.NEXT_OF_KIN,
        title: 'Step 1',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
    {
        step: 2,
        state: 'inactive',
        key: KYCFormKeys.IDENTITY_VERIFICATION,
        previousTitle: KycDictionary.Level_2,
        title: 'Step 2',
        required: true,
        mobileNote: 'Provide the information below',
        description: 'Identity Verification',
    },
    {
        step: 3,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        title: 'Step 3',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Residential)',
        iconName: 'location',
    },
    {
        step: 4,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
        title: 'Step 4',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Business)',
        iconName: 'location',
    },
];

export const KycIdentityVerificationTimeline: TimelineModel = {
    step: 3,
    state: 'inactive',
    key: KYCFormKeys.IDENTITY_VERIFICATION,
    previousTitle: KycDictionary.Level_2,
    title: 'Step 3',
    required: true,
    mobileNote: 'Provide the information below',
    description: 'Identity Verification',
    iconName: 'idVerification',
};

export const BrmKycWBOLvl2StepsV2: TimelineModel[] = [
    KycLevel2NinTimeline,
    {
        step: 2,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.NEXT_OF_KIN,
        title: 'Step 2',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
    KycIdentityVerificationTimeline,
    {
        step: 4,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        title: 'Step 4',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Residential)',
        iconName: 'location',
    },
    {
        step: 5,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.BUSINESS_PROOF_OF_ADDRESS,
        title: 'Step 5',
        mobileNote: 'Please upload the required documentation',
        description: 'Proof of Address (Business)',
        iconName: 'location',
    },
];

export const BrmKycWBOLvl2StepsV3: TimelineModel[] = [
    { ...KycLevel2NinTimeline },
    {
        step: 2,
        state: 'inactive',
        previousTitle: KycDictionary.Level_2,
        key: KYCFormKeys.NEXT_OF_KIN,
        title: 'Step 2',
        mobileNote: 'Enter your next of KIN’s details',
        description: 'Next of Kin',
        iconName: 'nextOfKin',
    },
];
export const TotalStepWOBOKycLvl2V2 = BrmKycWBOLvl2StepsV3.length;

export const BrmKycBOLvl3Steps: TimelineModel[] = [
    {
        step: 1,
        state: 'active',
        previousTitle: KycDictionary.Level_3,
        key: KYCFormKeys.PROOF_OF_ADDRESS,
        title: 'Step 1',
        mobileNote: '',
        description: 'Proof of Address Verification',
        iconName: 'location',
        canBeRejected: true,
    },
];

export const BusinessNameChangeStep: TimelineModel = {
    step: 3,
    key: KYCFormKeys.BUSINESS_NAME_CHANGE,
    state: 'inactive',
    previousTitle: KycDictionary.Level_4,
    title: 'Step 3',
    description: 'Business Names',
    mobileNote: 'Review your Business and account names',
    iconName: 'sign',
    required: true,
};

export const BusinessNameChangeStepV2: TimelineModel = {
    step: 6,
    key: KYCFormKeys.BUSINESS_NAME_CHANGE,
    state: 'inactive',
    previousTitle: KycDictionary.Level_4,
    title: 'Step 6',
    description: 'Business Names',
    mobileNote: 'Review your Business and account names',
    iconName: 'sign',
    required: true,
};

export enum BoAccountActivation {
    PROFILE = 1,
    OTP,
    PIN,
    FACE_VERIFICATION,
    ATTESTATION,
}

export const BoAccountActivationBOSteps: TimelineModel[] = [
    {
        step: 1,
        state: 'inactive',
        previousTitle: KycDictionary.Activate_Account,
        title: 'Step 1',
        required: true,
        mobileNote: 'Select your Username & Password',
        description: 'Create your Profile',
    },
    {
        step: 2,
        state: 'active',
        previousTitle: KycDictionary.Activate_Account,
        title: 'Step 2',
        required: true,
        mobileNote: 'We’ve just sent you a 6 digit code. Check your messages and enter it here.',
        description: 'Enter OTP',
    },
    {
        step: 3,
        state: 'inactive',
        previousTitle: KycDictionary.Activate_Account,
        title: 'Step 3',
        required: true,
        mobileNote: 'Setup a transaction PIN for your business. ',
        description: 'Business Transaction PIN',
    },
    {
        step: 4,
        state: 'inactive',
        previousTitle: KycDictionary.Activate_Account,
        title: 'Step 4',
        required: true,
        mobileNote: 'Provide the information below. ',
        description: 'Face Verification',
    },
    {
        step: 5,
        state: 'inactive',
        previousTitle: KycDictionary.Activate_Account,
        title: 'Step 5',
        required: true,
        mobileNote: 'Review the following information and attest',
        description: 'Attestation',
    },
];

export enum BrmKycOption {
    BRM_WITHOUT_BO,
    BRM_WITH_BO,
}

export enum BrmLivelinessType {
    PASSPORT,
    LIVELINESS,
}

export enum KycOnboardingAttestationSteps {
    RESIDENTIAL_ADDRESS,
    CONTACT_DETAILS,
    BUSINESS_DETAILS,
    ADDITIONAL_BUSINESS_DETAILS,
    BUSINESS_ADDRESS,
    SUPPORTING_DOCUMENTS_BUSINESS_DETAILS,
    SUPPORTING_DOCUMENTS,
    SIGNATURE,
    FACE_VERIFICATION,
    SOURCE_OF_INCOME,
    PEP,
    NATIONALITY,
}

export const KycRoutes = {
    BLACK_LISTED_BUSINESS_NAME_MOBILE_FORM: '/onboarding-v2/mobile-blacklisted-business-name-form',
    BO_LVL_1_ROUTE: '/onboarding-v2/kyc-lvl1',
    BO_LVL_2_ROUTE: '/onboarding-v2/kyc-lvl2',
    BO_LVL_3_ROUTE: '/onboarding-v2/kyc-lvl3',
    BO_LVL_4_ROUTE: '/onboarding-v2/kyc-lvl4',
    BO_LVL_5_ROUTE: '/onboarding-v2/kyc-lvl5',
    BO_AT_ROUTE: '/onboarding-v2/bo-account-activation',
    BO_LVL_2_MANUAL_REVIEW: '/onboarding-v2/bo-kyc-lvl2-manual-review',
    BO_LVL_3_MANUAL_REVIEW: '/onboarding-v2/bo-kyc-lvl3-manual-review',
    BRM_LVL_1_ROUTE: '/onboarding-v2/brm-kyc-lvl1',
    BRM_LVL_2_ROUTE: '/onboarding-v2/brm-kyc-lvl2',
    BRM_LVL_3_ROUTE: '/onboarding-v2/brm-kyc-lvl3',
    BRM_LVL_4_ROUTE: '/onboarding-v2/brm-kyc-lvl4',
    BRM_LVL_5_ROUTE: '/onboarding-v2/brm-kyc-lvl5',
    BRM_LVL_2_TERMINAL_ROUTE: '/onboarding-v2/brm-kyc-lvl2-terminal-view',
    BRM_LVL_2_MANUAL_REVIEW: '/onboarding-v2/brm-kyc-lvl2-manual-review',
    BRM_LVL_3_TERMINAL_ROUTE: '/onboarding-v2/brm-kyc-lvl3-terminal-view',
    BRM_LVL_3_MANUAL_REVIEW: '/onboarding-v2/brm-kyc-lvl3-manual-review',
    BRM_LVL_3_ACTION_REQUIRED: '/onboarding-v2/brm-kyc-lvl3-action-required',
    FAILED_MODAL: '/onboarding-v2/failed-modal',
    SUCCESS_MODAL: '/onboarding-v2/success-modal',
    BRM_KYC_LVL_1_SUCCESS_MODAL: '/onboarding-v2/brm-kyc-lvl1-business-creation-modal',
    BRM_KYC_LVL_2_SUCCESS_MODAL: '/onboarding-v2/brm-kyc-lvl2-business-creation-modal',
    BRM_KYC_LVL_3_SUCCESS_MODAL: '/onboarding-v2/brm-kyc-lvl3-business-creation-modal',
    BO_KYC_LVL_2_SUCCESS_MODAL: '/onboarding-v2/bo-kyc-lvl2-success-modal',
    BO_KYC_LVL_3_SUCCESS_MODAL: '/onboarding-v2/bo-kyc-lvl3-business-creation-modal',
    BO_KYC_LVL_4_SUCCESS_MODAL: '/onboarding-v2/bo-kyc-lvl4-business-creation-modal',
    BRM_KYC_LVL_4_SUCCESS_MODAL: '/onboarding-v2/brm-kyc-lvl4-business-creation-modal',
    BRM_KYC_LVL_5_SUCCESS_MODAL: '/onboarding-v2/brm-kyc-lvl5-business-creation-modal',
    BO_KYC_LVL_5_SUCCESS_MODAL: '/onboarding-v2/bo-kyc-lvl5-business-creation-modal',
    BRM_KYC_BUSINESS_DETAILS_REJECTION: '/onboarding-v2/brm-kyc-business-details-rejection',
    BO_KYC_BUSINESS_DETAILS_REJECTION: '/onboarding-v2/bo-kyc-business-details-rejection',
    BRM_KYC_SUPPORTING_DOCUMENT_REJECTION: '/onboarding-v2/brm-kyc-supporting-document-rejection',
    BO_KYC_SUPPORTING_DOCUMENT_REJECTION: '/onboarding-v2/bo-kyc-supporting-document-rejection',
    BRM_KYC_REVIEW_ROUTE: '/onboarding-v2/brm-kyc-document-review',
    BO_KYC_REJECTION_ROUTE: '/onboarding-v2/bo-kyc-document-rejection',
    BO_KYC_IDENTITY_TYPE_AFTER_ID_REJECTION: '/onboarding-v2/identity-type',
    BRM_KYC_IDENTITY_TYPE_AFTER_ID_REJECTION: '/onboarding-v2/brm-identity-type',
    BRM_KYC_REJECTION_ROUTE: '/onboarding-v2/brm-kyc-document-rejection',
    BRM_KYC_ID_REJECTION_ROUTE: '/onboarding-v2/brm-kyc-id-verification-rejection',
    BO_KYC_ID_REJECTION_ROUTE: '/onboarding-v2/bo-kyc-id-verification-rejection',
    BRM_KYC_POA_REJECTION_ROUTE: '/onboarding-v2/brm-kyc-proof-of-address-rejection',
    BO_KYC_POA_REJECTION_ROUTE: '/onboarding-v2/bo-kyc-proof-of-address-rejection',
    BRM_IDENTITY_VERIFICATION_ROUTE: '/api/v1/identity/verification-status',
    BLACKLISTED_NAME_VERIFICATION_ROUTE: '/api/v1/business-owner-onboarding/level-4/cac-verification-status',
    BLACKLISTED_NAME_VERIFICATION: '/onboarding-v2/blacklisted-name-verification',
    BO_LIVELINESS_VERIFICATION_ROUTE: '/api/v1/business-kycs/identity-verification-status?verificationType=liveliness',
    BO_IDENTITY_VERIFICATION_ROUTE: '/api/v1/business-kycs/identity-verification-status?verificationType=identity',
    BRM_LIVELINESS_VERIFICATION: '/onboarding-v2/brm-liveliness-verification',
    BRM_LVL_2_ID_VERIFICATION: '/onboarding-v2/brm-lvl2-id-verification',
    BO_LVL_2_ID_VERIFICATION: '/onboarding-v2/bo-lvl2-id-verification',
    BRM_REJECTION_META_MAP_ID_VERIFICATION: '/onboarding-v2/brm-rejection-meta-map-id-verification',
    BO_REJECTION_META_MAP_ID_VERIFICATION: '/onboarding-v2/bo-rejection-meta-map-id-verification',
    BO_LIVELINESS_VERIFICATION: '/onboarding-v2/bo-liveliness-verification',
    BO_AT_LIVELINESS_VERIFICATION: '/onboarding-v2/bo-account-activation-liveliness-verification',
    bo_setup_step_modal: '/onboarding-v2/bo-setup-step-modal',
    SUCCESS_BUSINESS_CREATION_MODAL: 'onboarding-v2/kyc-business-creation-modal',
    BRM_WITHOUT_BO_TERMINAL_PAGE: '/onboarding-v2/brm-with-out-bo-terminal',
    BO_DASHBOARD: '/main-app/business-user/dashboard',
    BRM_DASHBOARD: '/main-app/aggregator/brm-dashboard-v2/view',
    BRM_KYC_ACC_ACTIVATION_WBO: '/onboarding-v2/brm-kyc-customer-account-activation-v2-with-bo',
    BRM_KYC_ACC_ACTIVATION_WOBO: '/onboarding-v2/brm-kyc-customer-account-activation-v2-without-bo',
    BO_AT_MODAL_SUCCESS: '/onboarding-v2/bo-account-activation-successful',
    BO_KYC: '/onboarding-v2/kyc',
    BO_GENERAL_KYC_PRIMER: '/onboarding-v2/general-kyc-primer',
    USER_PIN: '/onboarding-v2/user-pin-creation',
    BUSINESS_OWNER_LIST_DASHBOARD: '/main-app/aggregator/business-owners/list',
    BUSINESS_OWNER_LIST_NON_COMPLIANT: '/main-app/aggregator/business-owners/list?currentTab=noncompliant',
    NIN_BVN_MISMATCH: '/onboarding-v2/bvn-nin-mismatch-v2',
    NIN_BVN_VERIFY_DETAILS: '/onboarding-v2/verify-nin-bvn-details',
};

export enum CustomMetaMapErrorCode {
    META_MAP_DONE,
    USER_SUSPENDED,
    META_MAP_ERROR,
    IN_REVIEW,
}

export const CustomerAccountActivationWithoutBoTask = [
    {
        icon: 'assets/images/svgs/bo-download.svg',
        text: 'Optionally Download Moniepoint Business app from Playstore or Appstore',
    },
    {
        icon: 'assets/images/svgs/bo-link.svg',
        text: 'Click on the link in the Account Activation Email just sent',
    },
    {
        icon: 'assets/images/svgs/bo-profile.svg',
        text: 'Create a profile - Username and Password',
    },
    {
        icon: 'assets/images/svgs/bo-pin.svg',
        text: 'Set up Transaction PIN for the business',
    },
    {
        icon: 'assets/images/svgs/bo-face-verification.svg',
        text: 'Face Verification',
    },
    {
        icon: 'assets/images/svgs/bo-attestation.svg',
        text: 'Attestation',
    },
    {
        icon: 'assets/images/svgs/bo-id.svg',
        text: 'ID Verification',
    },
    {
        icon: 'assets/images/svgs/bo-indemnity.svg',
        text: 'Indemnity',
    },
];

export const CustomerAccountActivationWithBoTask = [
    {
        icon: 'assets/images/svgs/bo-download.svg',
        text: 'Optionally Download Moniepoint Business app from Playstore or Appstore',
    },
    {
        icon: 'assets/images/svgs/bo-link.svg',
        text: 'Click on the link in the Account Activation Email just sent',
    },
    {
        icon: 'assets/images/svgs/bo-profile.svg',
        text: 'Create a profile - Username and Password',
    },
    {
        icon: 'assets/images/svgs/bo-pin.svg',
        text: 'Set up Transaction PIN for the business',
    },
];

export const MockKycLevelStatus = {
    kycLevelOneStatus: KycLvlState.COMPLETED,
    kycLevelTwoStatus: KycLvlState.REJECTED,
    kycLevelThreeStatus: KycLvlState.REJECTED,
    kycLevelFourStatus: KycLvlState.SUBMITTED,
    kycLevelFiveStatus: KycLvlState.SUBMITTED,
};

export const TestLoginResponse = {
    tokenData: {
        username: 'onus013',
        firstName: 'Johnny',
        lastName: 'Bravo',
        email: 'u@gmail.com',
        roles: ['MONNIFY_AGENCY_BANKING_AGENT', 'MONNIFY_AGENT_MANAGER'],
        authorities: ['mab_fo_cancel_terminal_subscription', 'mab_fo_send_pin_reset_otp', 'mab_fo_manage_business_moniepoint_feature'],
        hasMultipleBusiness: false,
        userType: 'Business',
        shouldCompleteSelfOnboardingKyc: false,
        hasUserPin: false,
        access_token:
            'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.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.FOmm-HECpBBCJ35wmODaL5BBNNsRJfnmw6YQ6b4fQEAoFGfcoGU-FAWcWAs6PnhrmfhQUe5E1WbzeYaBMXNi_O1MpxKHc8rKc4DMhK4oRAhjLZo0B_TbVS-6vsfke1ZQr_DQpiLTJcOhnyHgekGoaSEGblNWh3Y38wnFPqgzTOzQ1BaAjvrU0LSsWDJ1Ih3yjIme1jF8VJkYasS-D20TekMyWZdcJ5Sfh8WaOtbIbIlnLxMEKc_5vLOZXjYxh7Qqapm0WSfgi-L1O0VFhcqq19siklfWxJiODNagTrb6hBx4_CGXT2waSio4dX4Id_4jJ2D6fveT69s9nK29KNZKFg',
        expires_in: 86399,
    },
    adviceUpdate: false,
    forceUpdate: false,
};

export interface ICustomerKycHarmonizationGracePeriod {
    id?: number;
    status?: string;
    createdOn?: string;
    lastModifiedOn?: string;
    startTime: string;
    endTime: string;
    hasEnrolledInHierarchy: boolean;
    hasExpired: boolean;
}

export const DEFAULT_CRITICAL_TIME_IN_DAYS = 7;

export const MockKycData = {
    id: 233,
    status: 'ACTIVE',
    createdOn: '2023-07-06T15:49:14.000+0000',
    lastModifiedOn: '2023-07-06T18:51:13.000+0000',
    personalInformation: {
        houseAddress: '12',
        streetName: '',
        localGovernment: {
            id: 6,
            state: {
                id: 1,
                createdOn: '2018-07-27T18:03:06.000+0000',
                lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                country: {
                    id: 1,
                    createdOn: '2018-07-27T18:03:06.000+0000',
                    lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                    code: 'NG',
                    name: 'Nigeria',
                    dialCode: '234',
                    status: 'active',
                },
                code: 'LG',
                name: 'Lagos',
                enableWebDeposit: true,
                enableWebCashout: false,
                enableWebAirtimePurchase: true,
                enableWebBillPayment: true,
                status: 'active',
            },
            name: 'BADAGRY',
        },
        nationality: null,
        lgaOfOrigin: null,
        religion: null,
        employmentStatus: null,
        maritalStatus: null,
        proofOfAddressReference: '16b719c6-86cd-4ad7-bc8a-4c2e20c70682',
        personalAddressDocumentType: 'UTILITY_BILL',
    },
    nextOfKinInformation: {
        nextOfKinFirstName: 'aloma_aggregator',
        nextOfKinLastName: '',
        nextOfKinBirthDate: '2023-07-06',
        nextOfKinHouseNumber: null,
        nextOfKinStreetName: '12',
        nextOfKinPhoneNumber: '09096997556',
        relationship: 'SISTER',
        nextOfKinLocalGovernment: {
            id: 95,
            state: {
                id: 5,
                createdOn: '2018-07-27T18:03:06.000+0000',
                lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                country: {
                    id: 1,
                    createdOn: '2018-07-27T18:03:06.000+0000',
                    lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                    code: 'NG',
                    name: 'Nigeria',
                    dialCode: '234',
                    status: 'active',
                },
                code: 'AM',
                name: 'Anambra',
                enableWebDeposit: true,
                enableWebCashout: false,
                enableWebAirtimePurchase: true,
                enableWebBillPayment: true,
                status: 'active',
            },
            name: 'AYAMELUM',
        },
        nextOfKinNationality: {
            id: 1,
            code: 'NG',
            name: 'Nigeria',
        },
        nextOfKinLgaOfOrigin: {
            id: 95,
            state: {
                id: 5,
                createdOn: '2018-07-27T18:03:06.000+0000',
                lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                country: {
                    id: 1,
                    createdOn: '2018-07-27T18:03:06.000+0000',
                    lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                    code: 'NG',
                    name: 'Nigeria',
                    dialCode: '234',
                    status: 'active',
                },
                code: 'AM',
                name: 'Anambra',
                enableWebDeposit: true,
                enableWebCashout: false,
                enableWebAirtimePurchase: true,
                enableWebBillPayment: true,
                status: 'active',
            },
            name: 'AYAMELUM',
        },
    },
    businessKycInformation: {
        businessAddress: '12',
        city: 'ikd',
        localGovernment: {
            id: 115,
            createdOn: '2018-07-27T18:03:06.000+0000',
            lastModifiedOn: '2018-07-27T18:03:06.000+0000',
            state: {
                id: 6,
                createdOn: '2018-07-27T18:03:06.000+0000',
                lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                country: {
                    id: 1,
                    createdOn: '2018-07-27T18:03:06.000+0000',
                    lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                    code: 'NG',
                    name: 'Nigeria',
                    dialCode: '234',
                    status: 'active',
                },
                code: 'BA',
                name: 'Bauchi',
                enableWebDeposit: true,
                enableWebCashout: false,
                enableWebAirtimePurchase: true,
                enableWebBillPayment: true,
                status: 'active',
            },
            name: 'DARAZO',
            code: 'BA005',
            sanefCode: '102',
            status: 'active',
        },
        state: {
            id: 6,
            createdOn: '2018-07-27T18:03:06.000+0000',
            lastModifiedOn: '2018-07-27T18:03:06.000+0000',
            country: {
                id: 1,
                createdOn: '2018-07-27T18:03:06.000+0000',
                lastModifiedOn: '2018-07-27T18:03:06.000+0000',
                code: 'NG',
                name: 'Nigeria',
                dialCode: '234',
                status: 'active',
            },
            code: 'BA',
            name: 'Bauchi',
            enableWebDeposit: true,
            enableWebCashout: false,
            enableWebAirtimePurchase: true,
            enableWebBillPayment: true,
            status: 'active',
        },
        businessCategory: {
            id: 2,
            status: 'ACTIVE',
            createdOn: '2022-11-01T10:34:05.000+0000',
            lastModifiedOn: '2022-11-01T10:34:05.000+0000',
            name: 'Agriculture',
            description: 'Agriculture produce',
            iconLink: {
                id: 990,
                createdOn: '2022-11-01T10:34:04.000+0000',
                lastModifiedOn: '2022-11-01T10:34:04.000+0000',
                reference: '6efdf16b-090b-4c18-9764-3d0bc37d14d7',
                size: 35105,
                hash: '734503966ce676cf6665c9856e7c9678',
                type: 'image/png',
                originalName: '8501.png_300.png.png',
                status: 'active',
            },
        },
        businessSubCategory: {
            id: 3,
            status: 'ACTIVE',
            createdOn: '2023-03-03T12:48:10.000+0000',
            lastModifiedOn: '2023-03-03T12:48:10.000+0000',
            name: 'Rice Farming',
            code: 'RICE_FARMING',
            description: 'Rice Farming',
            businessCategory: {
                id: 2,
                status: 'ACTIVE',
                createdOn: '2022-11-01T10:34:05.000+0000',
                lastModifiedOn: '2022-11-01T10:34:05.000+0000',
                name: 'Agriculture',
                description: 'Agriculture produce',
                iconLink: {
                    id: 990,
                    createdOn: '2022-11-01T10:34:04.000+0000',
                    lastModifiedOn: '2022-11-01T10:34:04.000+0000',
                    reference: '6efdf16b-090b-4c18-9764-3d0bc37d14d7',
                    size: 35105,
                    hash: '734503966ce676cf6665c9856e7c9678',
                    type: 'image/png',
                    originalName: '8501.png_300.png.png',
                    status: 'active',
                },
            },
            default: false,
        },
        proofOfAddressReference: '16b719c6-86cd-4ad7-bc8a-4c2e20c70682',
        otherAccountPurpose: null,
        businessName: 'teamapt  limited9',
        businessType: 'REGISTERED',
        isPersonalAddressForBusiness: null,
        staffSize: null,
        businessDescription: null,
        registeredBusinessType: 'INCORPORATED_COMPANY',
        businessOwnerGreaterThanOne: false,
        taxIdentificationNumber: '00000000-0000',
        ownershipStructure: 'Privately Held (Pre-2017)',
        businessAddressDocumentType: 'UTILITY_BILL',
        businessPin: null,
        companyLogoReference: null,
        kycLevel: 4,
        cacbusinessRegistrationNumber: 'RC125377199',
    },
    identityVerificationCount: 0,
    identityVerificationReference: null,
    identityVerificationSuspensionReleaseTime: '2023-07-06T18:50:51.000+0000',
    providerIdentityVerificationStatus: 'SUCCESS',
    providerLivelinessVerificationStatus: 'SUCCESS',
    levelFourProviderLivelinessVerificationStatus: 'SUCCESS',
    bvnIdentityVerificationStatus: 'SUCCESS',
    signatureFileReference: '202ee5f6-3b16-42c3-a201-3ed79aed8f57',
    signatureDocumentType: null,
    identityVerificationDate: '2023-07-04T23:00:00.000+0000',
    cacVerificationReference: null,
    cacVerificationStatus: 'SUCCESS',
    cacAffiliatesVerificationStatus: 'SUCCESS',
    reasonForUncompletedBusinessInformation: null,
    identityDocumentExpired: false,
    updateAttemptCount: 4,
    agentId: 6339,
    kycLevelStatus: {
        kycLevelOneStatus: 'COMPLETED',
        kycLevelTwoStatus: 'COMPLETED',
        kycLevelThreeStatus: 'REJECTED',
        kycLevelFourStatus: 'REJECTED',
        kycLevelFiveStatus: 'REJECTED',
    },
    kycDashboardData: {
        kycDeadlineDate: null,
        kycVerificationStatus: 'REJECTED',
        rejectionReason: 'Rejected for rejection reason',
        kycBannerText: null,
        kycAgreementText: null,
        businessOwnerKycVerificationStatus: 'APPROVED',
        businessOwnerKycRejectionReason: null,
        businessOwnerUtilityVerificationStatus: 'APPROVED',
        kycDashboardRegisteredBusinessDocumentStatus: {
            certifiedApplicationForm: 'PENDING',
            certificateOfBusinessName: 'PENDING',
            memat: 'PENDING',
            certificateOfIncorporation: 'PENDING',
            boardResolution: 'PENDING',
            cac2: 'REJECTED',
            cac3: 'REJECTED',
            cac7: 'REJECTED',
            cacIt: 'PENDING',
        },
        registeredBusinessType: 'INCORPORATED_COMPANY',
        ownershipStructure: 'Privately Held (Pre-2017)',
        kycLevelStatus: {
            kycLevelOneStatus: 'COMPLETED',
            kycLevelTwoStatus: 'COMPLETED',
            kycLevelThreeStatus: 'REJECTED',
            kycLevelFourStatus: 'REJECTED',
            kycLevelFiveStatus: 'REJECTED',
        },
        kycLevelTransactionLimit: null,
        kycCurrentLevel: 2,
    },
    isBusinessOwnerPresent: null,
    phoneNumber: null,
    email: null,
    kycLevelTransactionLimit: {
        kycLevelOneTransactionLimit: {
            singleCreditLimit: '500000',
            dailyCreditLimit: '500000',
            singleDebitLimit: '50000',
            dailyDebitLimit: '200000',
        },
        kycLevelTwoTransactionLimit: {
            singleCreditLimit: '5000000',
            dailyCreditLimit: '5000000',
            singleDebitLimit: '900000',
            dailyDebitLimit: '900000',
        },
        kycLevelThreeTransactionLimit: {
            singleCreditLimit: 'Unlimited',
            dailyCreditLimit: 'Unlimited',
            singleDebitLimit: '10000000',
            dailyDebitLimit: '100000000',
        },
        kycLevelFourTransactionLimit: {
            singleCreditLimit: 'Unlimited',
            dailyCreditLimit: 'Unlimited',
            singleDebitLimit: '50000000',
            dailyDebitLimit: '250000000',
        },
        kycLevelFiveTransactionLimit: {
            singleCreditLimit: 'Unlimited',
            dailyCreditLimit: 'Unlimited',
            singleDebitLimit: 'Unlimited',
            dailyDebitLimit: 'Unlimited',
        },
    },
    customerFirstName: null,
    customerLastName: null,
    hasProfile: null,
    currentTransactionLimitsKycLevel: 5,
    pendingKycRequestSource: 'OLD_BRM_ONBOARDED_BUSINESS_OWNERS',
    customerKycHarmonizationGracePeriod: {
        id: 20,
        status: 'ACTIVE',
        createdOn: '2023-07-06T15:49:14.000+0000',
        lastModifiedOn: '2023-07-06T16:08:30.000+0000',
        startTime: '2023-07-06T15:49:14.000+0000',
        endTime: '2023-09-04T15:49:14.000+0000',
        hasEnrolledInHierarchy: false,
        hasExpired: false,
    },
    personalProofOfAddressVerificationStatus: 'APPROVED',
    businessProofOfAddressVerificationStatus: 'REJECTED',
    fromKycHarmonization: true,
    has_concluded_onboarding: true,
    has_completed_indemnity: true,
    has_completed_next_of_kin_information: true,
    has_business_pin: false,
    has_completed_personal_information: true,
    has_proof_of_address: true,
    has_business_proof_of_address: true,
    has_completed_identity_verification: true,
    has_completed_business_documentation: true,
    has_completed_contact_details: false,
    has_uploaded_signature_file: true,
    registered_business_fields: {
        certifiedApplicationForm: '108571c3-2df2-4952-b34f-79a95f0e4a1c',
        certificateOfBusinessName: 'f2feb114-dbf0-468a-9a48-ccb9b976812a',
        cacIt: null,
        memat: 'f742bf15-b574-4eca-85fe-e9edf6171871',
        cac2: '7af2bb82-2018-4488-bcb7-3a4aa3e4ff2f',
        cac3: 'c8743b8d-27bf-4bcf-9c9b-64cb2c526dbf',
        cac7: 'd4773e0c-3e2d-4681-b68f-9bef24ff79bc',
        certificateOfIncorporation: '3059fc88-212c-457f-b540-d1388ec95c92',
        boardResolution: '7a181491-e0d5-4053-802c-75654cd2bbd8',
        companyLetterOfAuthorization: null,
        governmentApprovalDocument: null,
        businessOwnerDocument: null,
        cooperativeCertificate: null,
        operatingLicense: null,
        tcNoticeOfSituation: null,
        particularsOfDirectors: null,
        statementOfShareCapital: null,
        businessNumber: 'RC125377199',
        tin: '00000000-0000',
        ownershipStructure: 'Privately Held (Pre-2017)',
    },
    has_completed_liveliness_verification_for_level_four: true,
    has_completed_business_information: true,
    has_completed_business_address: true,
    has_completed_liveliness_verification: true,
};

export const DefaultKycLevelStatus = {
    kycLevelOneStatus: KycLvlState.NOT_STARTED,
    kycLevelTwoStatus: KycLvlState.NOT_STARTED,
    kycLevelThreeStatus: KycLvlState.NOT_STARTED,
    kycLevelFourStatus: KycLvlState.NOT_STARTED,
    kycLevelFiveStatus: KycLvlState.NOT_STARTED,
};

export enum MONNIFY_ROLES {
    MONNIFY_AGENT_MANAGER = 'MONNIFY_AGENT_MANAGER',
    MONNIFY_AGENCY_BANKING_AGENT = 'MONNIFY_AGENCY_BANKING_AGENT',
}

export enum ID_TYPE_ENUM {
    NIN_SLIP = 'NIN_SLIP',
    PASSPORT = 'PASSPORT',
    DRIVER_LICENCE = 'DRIVER_LICENCE',
    VOTER_CARD = 'VOTER_CARD',
}

export interface IdType {
    documentType: ID_TYPE_ENUM;
    name: string;
}

export enum TOKEN_DOMAINS {
    MONIEPOINT_BUSINESS_BANKING = 'MONIEPOINT_BUSINESS_BANKING',
    MONIEPOINT_PERSONAL_BANKING = 'MONIEPOINT_PERSONAL_BANKING',
}

export const RolesEligibleForSoftOnboarding: string[] = [
    UserAlias.consumerOwner,
    UserAlias.agent,
    UserAlias.agentManager,
    UserAlias.personalBankingOwner,
];

export const SOFT_ONBOARDING_ROUTE = '/onboarding-v2/soft-onboarding';
export const SOFT_ONBOARDING_SPLASH_SCREEN_ROUTE = '/onboarding-v2/soft-onboarding-splash-screen';

export interface BusinessNameDetails {
    businessNameDetails: BusinessNameDetail[];
}
export interface BusinessNameDetail {
    businessId: number;
    currentBusinessName?: string;
    currentAccountName?: string;
    legalName: string;
    combinedName?: string;
    businessNameReviewStatus?: boolean;
    accountNameReviewStatus?: boolean;
    nameLimitExceededMessage?: string;
    nameLimitExceeded?: boolean;
}

export enum BusinessNameChangeType {
    CUSTOM = 'CUSTOM',
    ACCOUNT = 'ACCOUNT',
    BUSINESS = 'BUSINESS',
}

export enum BusinessNameComponentVariant {
    EDIT,
    DEFAULT,
    DISPLAY,
    DETAILS,
    LIST,
}

export const MockBusinessNames: BusinessNameDetail[] = [
    {
        businessId: 122,
        legalName: 'Smackers Limited',
        currentBusinessName: 'Smackers Limited - The Place \n' + 'Computer Village',
        currentAccountName: 'Smackers Limited',
        businessNameReviewStatus: true,
        combinedName: 'Smackers Limited - Onome',
        accountNameReviewStatus: false,
    },
    {
        businessId: 123,
        legalName: 'Smackers Limited',
        currentBusinessName: 'Smackers Limited - The Place Igbobi',
        currentAccountName: 'Smackers - The Place Maryland',
        combinedName: 'Smackers - Hero',
        businessNameReviewStatus: false,
        accountNameReviewStatus: true,
    },
    {
        businessId: 124,
        legalName: 'Smackers Limited',
        currentBusinessName: 'Smackers Limited - The Place Olorunshogo',
        currentAccountName: 'Smackers - The Place Maryland',
        combinedName: 'Smackers - Nicholas',
        businessNameReviewStatus: false,
        accountNameReviewStatus: false,
    },
];

export enum KYC_IDENTITY_TYPE {
    NIN = 'NIN',
    BVN = 'BVN',
    NIN_OR_BVN = 'NIN_OR_BVN',
    CONFIRM_ID = 'CONFIRM_ID',
}

export interface AsyncLivenessStatus {
    asyncLivelinessInProgress: boolean;
    statusCode: string;
    message: string;
}

export enum AsyncLivenessStatusCode {
    FIRST_TIME_USER_FOR_ASYNC_LIVELINESS = '400057',
    LIVELINESS_VERIFICATION_IN_PROGRESS = '400239',
    PREVIOUSLY_COMPLETED_LIVELINESS_VERIFICATION = '400056',
    INVALID_BVN_NIN = '400236',
    NIN_INVALID = '400069',
    BVN_INVALID = '400068',
    FACE_MATCH_FAILED = '400055',
    PREVIOUSLY_FAILED_CALLBACK_PROCESSING = '400060',
    BVN_NIN_VALID_BUT_LIVELINESS_NOT_INITIATED = '400058',
    BVN_NIN_VALID_BUT_LIVELINESS_FAILED = '400059',
    OLD_LIVELINESS_FLOW = '400070',
    ASYNC_LIVELINESS_HAS_EXCEEDED_SUBMISSION_WAIT_TIME = '400067',
}

export enum KycIdentity {
    NIN = 'CONFIRM_ID',
    BVN = 'CONFIRM_ID',
}

export const DefaultIdentityForm = {
    title: 'Select an option',
    subTitle: 'Select the type of ID to validate',
};
export const NinIdentityForm = {
    title: 'Verify your NIN',
    subTitle: 'Enter your 11 Digit NIN.',
};
export const ConfirmNinID = {
    title: 'Is this NIN yours?',
    subTitle: 'Confirm the NIN details shown below belong to you',
};
export const ConfirmBvnID = {
    title: 'Is this BVN yours?',
    subTitle: 'Confirm the BVN details shown below belong to you',
};
export const BvnIdentityForm = {
    title: 'Verify your BVN',
    subTitle: 'Enter your 11 Digit BVN.',
};

export const ProofOfAddressResidentialForm = {
    subTitle: 'Please upload the required documentation',
    title: 'Proof of Address (Residential)',
};
export const ProofOfAddressBusinessForm = {
    subTitle: 'Please upload the required documentation',
    title: 'Proof of Address (Business)',
};

export interface KycIdentityType {
    type: string;
    value: string;
    image: string;
    firstName: string;
    lastName: string;
    mobileNumber: string;
    status: string;
}

export enum KycIdentityTypeStatus {
    FOUND = 'FOUND',
}

export interface KycIdentityToken {
    tokens: KycIdentityType[];
}

export enum KYC_LEVEL3_FLOW {
    PROOF_OF_ADDRESS = 'PROOF_OF_ADDRESS',
}

export const VERIFICATION_VARIANT = {
    ONE: 'ONE',
    TWO: 'TWO',
} as const;

export type VerificationVariant = typeof VERIFICATION_VARIANT[keyof typeof VERIFICATION_VARIANT];

export const ONBOARDING_ROUTE = ['onboarding-v2', 'onboarding', 'kyc'];

export const ONBOARDING_BLACKLISTED_PREVIOUS_ROUTE = ['profile-setup', 'kyc'];

export interface OnboardingCreateNationality {
    residentPermitReference?: string;
    countryId: number;
    requestId?: number;
}

export interface OnboardingCreateSourceOfWealth {
    occupationsId?: number;
    expectedAnnualIncomeRevenueRangesId?: number;
    otherAnnualIncomeRevenueRangesId?: number;
    otherAnnualIncomeRevenueSourcesId?: number;
    additionalCategories: CreateSourceOfWealthAdditionalCategory[];
    userType: 'BUSINESS' | 'PERSONAL';
    requestId: number;
}

export interface CreateSourceOfWealthAdditionalCategory {
    categoryId: number;
    subCategoryId: number;
}

export interface OnboardingCreatePepInfo {
    isCurrentOrPastPublicOfficeHolder: boolean;
    publicOfficePosition: string;
    startDate: string;
    endDate: string;
    isRelatedToCurrentOrPastPublicOfficeHolder: boolean;
    relationToPep: string;
    relativeFullName: string;
    relativePublicOfficePosition: string;
}

export interface OnboardingAdditionalBusinessDetailsResponse {
    posCategoryChosen: boolean;
}

export const KYC_LVL1_BUSINESS_TYPE = {
    UNREGISTERED: 'UNREGISTERED',
} as const;

type KycLvl1BusinessType = typeof  KYC_LVL1_BUSINESS_TYPE[keyof typeof KYC_LVL1_BUSINESS_TYPE];

export interface UpdateBusinessInformation {
    accountForOutsideBusinessCategory: boolean,
    businessName?: string,
    businessCategory?: number,
    businessDescription?: string,
    businessSubCategoryId?: number,
    businessSubCategoryIds?: Array<number>,
    businessType: KycLvl1BusinessType,
    companyLogoReference?:string
    staffSize?: number,
    otherBusinessPurpose?: string,
}

export interface PepInformation {
    id?: number;
    isCurrentOrPastPublicOfficeHolder: boolean;
    publicOfficePosition?: string;
    startDate?: string;
    endDate?: string;
    isRelatedToCurrentOrPastPublicOfficeHolder: boolean;
    relationToPep?: string;
    relativeFullName?: string;
    relativePublicOfficePosition?: string;
}

export interface KycPersonalInformationNationality {
    id: number;
    code: string;
    name: string;
}

export interface KycPersonalInformationSourceOfWealth {
    id: number;
    createdOn: string;
    lastModifiedOn: string;
    occupations?: any;
    expectedAnnualIncomeRevenueRanges: ExpectedAnnualIncomeRevenueRanges;
    otherAnnualincomeRevenueSources: OtherAnnualincomeRevenueSources;
    otherAnnualincomeRevenueRanges: ExpectedAnnualIncomeRevenueRanges;
    userType: string;
    additionalCategories: SourceOfWealthAdditionalCategory[];
    status: string;
}

interface SourceOfWealthAdditionalCategory {
    id: number;
    createdOn: string;
    lastModifiedOn: string;
    sourceOfWealthId: number;
    category: KycSourceOfWealthCategory;
    subCategory: KycSourceOfWealthSubCategory;
    status: string;
}

interface KycSourceOfWealthSubCategory {
    id: number;
    status: string;
    createdOn: string;
    lastModifiedOn: string;
    name: string;
    code: string;
    description: string;
    businessCategory: KycSourceOfWealthCategory;
    scuml: boolean;
    operatingLicense: boolean;
    licenseType: string;
    default: boolean;
}

interface KycSourceOfWealthCategory {
    id: number;
    status: string;
    createdOn: string;
    lastModifiedOn: string;
    name: string;
    description: string;
    iconLink?: any;
}

interface OtherAnnualincomeRevenueSources {
    id: number;
    createdOn: string;
    lastModifiedOn: string;
    categoryName: string;
    status: string;
}

interface ExpectedAnnualIncomeRevenueRanges {
    id: number;
    createdOn: string;
    lastModifiedOn: string;
    minValue: number;
    maxValue: number;
    displayText: string;
    status: string;
}

export enum PepCurrentView {
    CONFIRM = 'CONFIRM',
    FORM = 'FORM',
}

export interface PepScreeningStatus {
    pepScreeningStatus: boolean;
    pepScreeningBlacklistStatus: boolean;
}

export enum BusinessClaim {
    NOT_CLAIMED = 0,
    BUSINESS_NOT_MINE,
    BUSINESS_IS_MINE,
}

export enum CacVerificationStatus {
    BUSINESS_FOUND = 1,
    BUSINESS_NOT_FOUND,
    AFFILIATE_NOT_FOUND,
}

export enum KycLevel4Step {
    BUSINESS_DETAIL = 1,
    SUPPORTING_DOCUMENTS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlow {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlowWithoutTIN {
    BUSINESS_DETAIL = 1,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlowWithoutScuml {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlowWithoutScumlAndTIN {
    BUSINESS_DETAIL = 1,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlowWithoutBusinessName {
    BUSINESS_DETAIL = 1,
    TIN_DETAIL,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepForAffiliateFlowWithoutBusinessNameAndTIN {
    BUSINESS_DETAIL = 1,
    AFFILIATE_DETAIL,
    SUPPORTING_DOCUMENTS,
    SCUML_DETAILS,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export enum KycLevel4StepWithBusinessNameFlow {
    BUSINESS_DETAIL = 1,
    SUPPORTING_DOCUMENTS,
    BUSINESS_NAME_CHANGE,
    SUPPORTING_DOCUMENTS_SUMMARY,
}

export interface BvnNinMisMatchError {
    code: string;
    phoneNumberIssues?: {
        ninPhoneNumber: string;
        bvnPhoneNumber: string;
        issues?: Array<{ issueType: string; message: string }>;
    };
    dateOfBirthIssues?: {
        ninDateOfBirth: string;
        bvnDateOfBirth: string;
        issues?: Array<{ issueType: string; message: string }>;
    };
    nameIssue?: {
        ninName: {
            firstName: string;
            middleName: string;
            lastName: string;
        };
        bvnName: {
            firstName: string;
            middleName: string;
            lastName: string;
        };
        issues?: Array<{ issueType: string; message: string }>;
    };
}

export enum KycLevel3StepWithPhysicalAddressFlow {
    PHYSICAL_ADDRESS_VALIDATION = 1,
    INDEMNITY,
}

export enum AddressType {
    residential = 'residential',
    business = 'business',
}

export const KycLevelNameMap = {
    0: 'Level 1',
    1: 'Level 1',
    2: 'Level 2',
    3: 'Level 3',
    4: 'Registered Business',
    5: 'Registered Business Plus',
};

export const KycLevelNameShortMap = {
    0: 'Level 1',
    1: 'Level 1',
    2: 'Level 2',
    3: 'Level 3',
    4: 'Registered',
    5: 'Registered Plus',
};

export const KycLevelProgressLabelMap = {
    0: 'Lvl 1',
    1: 'Lvl 1',
    2: 'Lvl 2',
    3: 'Lvl 3',
    4: 'Registered',
    5: 'Registered Plus',
};

export const KycLevelProgressLabelShortMap = {
    0: 'Lvl 1',
    1: 'Lvl 1',
    2: 'Lvl 2',
    3: 'Lvl 3',
    4: 'Registered',
    5: 'Registered+',
};

export interface ISOCode {
    code: string;
    name: string;
}

export interface OnboardingAddress {
    state: ISOCode;
    lga: ISOCode;
    country: ISOCode;
    city: string;
    addressLineOne: string;
    addressLineTwo: string;
    type: OnboardingAddressType;
    canVerifyBusinessWithResidentialAddress: boolean;
    proofOfAddressSubmitted: boolean;
}

export enum OnboardingAddressType {
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
}

export interface CountDown {
    days?: number;
    hours?: number;
    minutes?: number;
    seconds?: number;
}

export const URL_REDIRECT_MAP = {
    'brm-kyc-lvl4': 'brm-kyc-registered',
    'brm-kyc-lvl5': 'brm-kyc-registered-plus',
    'bo-kyc-lvl5': 'bo-kyc-registered-plus',
    'kyc-lvl4-primer': 'kyc-registered-primer',
    'kyc-lvl5-primer': 'kyc-registered-plus-primer',
    'kyc-lvl4': 'kyc-registered',
    'kyc-lvl5-re-upload-document': 'kyc-registered-plus-re-upload-document',
    'kyc-lvl5': 'kyc-registered-plus',
    'brm-kyc-lvl4-manual-review': 'brm-kyc-registered-manual-review',
    'brm-kyc-lvl4-business-creation-modal': 'brm-kyc-registered-business-creation-modal',
    'bo-kyc-lvl4-business-creation-modal': 'bo-kyc-registered-business-creation-modal',
    'brm-kyc-lvl5-business-creation-modal': 'brm-kyc-registered-plus-business-creation-modal',
    'bo-kyc-lvl5-business-creation-modal': 'bo-kyc-registered-plus-business-creation-modal',
} as const;

export const EXISTING_PROFILE_CODE = 400224;

export const NIGERIA_COUNTRY_CODE = 'NG';

export const hasNationalityStep = (
    steps: BrmKycLevel1Steps | KycLevel1Steps,
): steps is (BrmKycLevel1Steps | KycLevel1Steps) & { NATIONALITY: number } => {
    return 'NATIONALITY' in steps;
};

export const hasAdditionalBusinessDetailsStep = (
    steps: BrmKycLevel1Steps | KycLevel1Steps,
): steps is (BrmKycLevel1Steps | KycLevel1Steps) & { ADDITIONAL_BUSINESS_DETAILS: number } => {
    return 'ADDITIONAL_BUSINESS_DETAILS' in steps;
};

export interface FaceVerificationStatus {
    isRequired: boolean;
}

export interface FaceVerificationStatusUpdate {
    status: string;
}

export interface AddressV2 {
    data: AddressData;
    metadata: {
        resultCode: DocumentVerificationResultCodes;
    };
}

export interface AddressData {
    results: AddressV2Details[];
    metadata: Metadata;
}

export interface AddressV2Details {
    type?: string;
    userReference: string;
    reference?: string;
    sourceReference?: string;
    addressLineOne?: string;
    addressLineTwo?: string;
    area?: string;
    city?: string;
    colorOfHouse?: string;
    countryCode?: string;
    majorLandmark?: string;
    localGovernmentCode?: string;
    latitude?: number;
    longitude?: number;
    captureLocationLatitude?: number;
    captureLocationLongitude?: number;
    notes?: string;
    approvalStatus: ApprovalStatus;
    dataVerificationStatus: ApprovalStatus;
}

export interface UploadedDocumentDetails {
    name: string;
    value: any;
}

export interface SupportedDocumentTypes {
    data: {
        transactionLimits: TransactionLimitByDocumentType;
        documentTypes: DocumentTypeModel[];
    };
    metadata: {
        resultCode: DocumentVerificationResultCodes;
    };
}

export interface TransactionLimitByDocumentType {
    verifiableDocument: TransactionTypes;
    unVerifiableDocument: TransactionTypes;
}

export interface TransactionTypes {
    debits: TransactionLimits;
    credits: TransactionLimits;
}

export interface TransactionLimits {
    singleTransactionLimit: number;
    dailyLimit: number;
}

export interface Metadata {
    totalCount: number;
    resultsCount: number;
    offset: number;
}

export interface AddressVerificationResponse {
    data: AddressVerificationData;
    metadata: AddressVerificationMetaData;
}

export interface AddressVerificationDryRunResponse {
    data: AddressVerificationDryRunData;
    metadata: AddressVerificationMetaData;
}

export interface DocumentVerificationDryRunPayload {
    addressReference: string;
    documentReference: string;
    documentType: KYCV2DocumentTypes,
    documentSource: string,
    metadata:ElectricityBillMetaDataV2 | Record<string, any>;
}

export interface ElectricityBillMetaDataV2 {
    meterAddress: string;
    meterNumber: string;
    meterProvider: string;
    meterType: string;
    documentContentType?: string;
}



export interface AddressVerificationMetaData {
    errors?: ErrorMessageDetail[];
    resultCode: DocumentVerificationResultCodes;
}

export interface AddressVerificationDryRunPayload {
    addressReference: string;
    documentReference: string;
    documentType: string;
    documentSource: string;
    metadata: any;
}

export interface AddressVerificationDryRunData {
    systemMetadata: SystemMetadata;
    warnings: Array<ErrorMessageDetail>;
    errors: Array<ErrorMessageDetail>;
}

export interface ElectricityBillMetadata {
    nameOnMeter: string;
    nameOnDocument: string;
    meterAddress: string;
    addressOnDocument: string;
    meterNumber: string;
    meterType: string;
    meterProvider: string;
    paymentDate: string;
    supportedProviders: Record<string, string>;
}

export interface ParsingResultMetadata {
    parsingStatusCode: AddressVerificationParsingResultCode;

}

export enum AddressVerificationParsingResultCode {
    DOCUMENT_PARSING_IN_PROGRESS = 'DOCUMENT_PARSING_IN_PROGRESS',
    UNABLE_TO_VERIFY_DOCUMENT = 'UNABLE_TO_VERIFY_DOCUMENT',
    DOCUMENT_NOT_VALID_NG_ELECTRICITY_BILL = 'DOCUMENT_NOT_VALID_NG_ELECTRICITY_BILL',
    UNSUPPORTED_CONTENT_TYPE = 'UNSUPPORTED_CONTENT_TYPE',
    MISSING_CONTENT_TYPE = 'MISSING_CONTENT_TYPE',
}

export interface OtherMetadata {
    [key: string]: any;
}

export type SystemMetadata = Partial<ElectricityBillMetadata> & Partial<ParsingResultMetadata> & OtherMetadata;

export interface AddressVerificationData {
    type: KYCDocumentType;
    status: string;
    statusMetadata: Record<string, string>;
    comment: string;
    reference: string;
    documentReference: string;
    source: string;
    version: string;
    metadata: Record<string, string>;
}

export type ErrorMessageDetail = {
    code: string;
    metadata?: Record<string, any>;
} & ({ message: string; description?: never } | { description: string; message?: never });

export interface PreviousBillPaymentResponse {
    data: PreviousBillPaymentData[];
    metadata: Metadata;
}

export interface PreviousBillPaymentData {
    documentType: KYCV2DocumentTypes;
    metadata: Record<string, any>;
    reference: string;
}

export enum ProofOfAddressVerificationV3Stages {
    VERIFICATION = 1,
    UPLOAD_DOCUMENT,
    CONFIRM_DETAILS,
    SUCCESS,
}

export enum DocumentModalState {
    SELECT = 1,
    DETAILS,
}

export enum UserActionRequiredStage {
    PHYSICAL_VERIFICATION = 'PHYSICAL_VERIFICATION',
    DOCUMENT_VERIFICATION = 'DOCUMENT_VERIFICATION',
}

export enum ApprovalStatus {
    PENDING = 'PENDING',
    PROCESSING = 'PROCESSING',
    APPROVED = 'APPROVED',
    REJECTED = 'REJECTED',
}

export enum DocumentVerificationResultCodes {
    OK = 'OK',
    COMPLETED = 'COMPLETED',
    APPROVED = 'APPROVED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED',
    ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
    VERIFICATION_NOT_FOUND = 'VERIFICATION_NOT_FOUND',
    DOCUMENT_TYPE_UNSUPPORTED = 'DOCUMENT_TYPE_UNSUPPORTED',
    METER_NUMBER_BLACKLISTED = 'METER_NUMBER_BLACKLISTED',
    OVER_USED_METER = 'OVER_USED_METER',
    METER_NO_NOT_FOUND = 'METER_NO_NOT_FOUND',
    EXPIRED_DOCUMENT = 'EXPIRED_DOCUMENT',
    NAME_ON_DOCUMENT_NOT_NAME_ASSIGNED_TO_METER = 'NAME_ON_DOCUMENT_NOT_NAME_ASSIGNED_TO_METER',
    DOCUMENT_HAS_MISSING_OR_INVALID_FIELDS = 'DOCUMENT_HAS_MISSING_OR_INVALID_FIELDS',
    METER_ADDRESS_NOT_DOCUMENT_ADDRESS = 'METER_ADDRESS_NOT_DOCUMENT_ADDRESS',
    METER_ADDRESS_NOT_VERIFICATION_ADDRESS = 'METER_ADDRESS_NOT_VERIFICATION_ADDRESS',
    OVERUSED_ELECTRICTY_BILL = 'OVERUSED_ELECTRICTY_BILL',
    METER_ADDRESS_GEOCODING_FAILED = 'METER_ADDRESS_GEOCODING_FAILED',
}

export enum PhysicalVerificationResultCodes {
    COMPLETED = 'COMPLETED',
    ADDRESS_NOT_FOUND = 'ADDRESS_NOT_FOUND',
    VERIFICATION_NOT_FOUND = 'VERIFICATION_NOT_FOUND',
    STRATEGY_UNSUPPORTED = 'STRATEGY_UNSUPPORTED',
    STRATEGY_NOT_ALLOWED = 'STRATEGY_NOT_ALLOWED',
    VERIFICATION_NOT_ALLOWED = 'VERIFICATION_NOT_ALLOWED',
    NOT_AT_LOCATION = 'NOT_AT_LOCATION',
    ADDRESS_MISMATCH = 'ADDRESS_MISMATCH',
    NOT_IN_COUNTRY = 'NOT_IN_COUNTRY',
    CREATED = 'CREATED',
    ACCEPTED = 'ACCEPTED',
}

enum DocumentVerificationErrorCategories {
    Name_Issues = 'Name Issues',
    Address_Issues = 'Address Issues',
    POA_Issues = 'POA Issues',
}

export const DocumentVerificationModalContents: Record<string, any> = {
    COMPLETED: {
        modalTitle: 'Utility Bill Approved',
        modalDescription: 'Please continue upgrading',
        proceedText: 'Continue upgrade',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    ACCEPTED: {
        modalTitle: 'Document Successfully Submitted!',
        modalDescription: 'Verification in progress – this may take up to 30 minutes.',
        proceedText: 'Continue To Next Step',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    PROCESSING: {
        modalTitle: 'Processing',
        modalDescription: 'Processing initiated. Give at least 30 minutes for final result',
        proceedText: 'Continue upgrade',
        cancelText: 'Dismiss',
        showCancelText: true,
    },
    REJECTED: {
        modalTitle: 'Account verification issues',
        modalDescription: 'Please ensure you check the requirements for each document. Your utility bill was rejected due to the following reasons',
        proceedText: 'Re-upload Proof of Address',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    WARNING: {
        modalTitle: 'Utility Bill Warning',
        modalDescription: 'Your utility bill has the following warnings',
        proceedText: 'Continue',
        cancelText: 'Use Another Proof of Address',
        showCancelText: true,
    },
    ADDRESS_NOT_FOUND: {
        modalTitle: 'Address Not Found',
        proceedText: 'Re-initiate Address Collection',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    DOCUMENT_TYPE_UNSUPPORTED: {
        modalTitle: 'Unsupported Document Type',
        proceedText: 'Re-upload Proof of Address',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    UNABLE_TO_VERIFY_DOCUMENT: {
        modalTitle: 'Verification Failed',
        modalDescription: 'The uploaded document could not be automatically verified.',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
    UNSUPPORTED_CONTENT_TYPE: {
        modalTitle: 'Unsupported Content Type',
        modalDescription: 'The request was sent to AVS without a content type being specified.',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
    DOCUMENT_NOT_VALID_NG_ELECTRICITY_BILL: {
        modalTitle: 'Invalid Electricity Bill',
        modalDescription: 'The uploaded document was detected to not be a valid Nigeria electricity bill.',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
    MISSING_CONTENT_TYPE: {
        modalTitle: 'Missing Content Type',
        modalDescription: 'The request was sent to AVS without a content type being specified.',
        proceedText: 'Dismiss',
        showCancelText: false,
    },
};

export enum DocumentVerificationErrorCodes  {
    UNABLE_TO_VERIFY_DOCUMENT = 'UNABLE_TO_VERIFY_DOCUMENT'
}

export const DocumentVerificationErrorCodesMap = {
    ADDRESS_NOT_FOUND: {
        getDescription: () => 'The address you have provided does not exist. Please provide another address to proceed with your account upgrade',
        issueCategory: DocumentVerificationErrorCategories.Address_Issues,
        title: 'Address Not Found',
    },
    UNPROCESSABLE_ENTITY: {
        getDescription: () =>
            'We were unable to process the information on your document. Kindly reupload a clearer document or provide another document to proceed.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Document Not Clear',
    },
    VERIFICATION_NOT_FOUND: {
        getDescription: () =>
            `We were unable to verify the details on your uploaded document. Kindly upload another document to proceed with your account upgrade`,
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Document Verification Failed',
    },
    DOCUMENT_TYPE_UNSUPPORTED: {
        getDescription: (docType: string) => `The document type you uploaded is not supported. Kindly upload a pdf, jpeg or png file type`,
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Unsupported Document Type',
    },
    METER_NUMBER_BLACKLISTED: {
        modalTitle:'Blacklisted Meter Number',
        getDescription: (meterNumber: string) =>
            `The meter number is blacklisted.`,
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Frequent Use of Electricity Bill',
    },
    OVER_USED_METER: {
        modalTitle:'Overused Meter',
        getDescription: () =>
            'The electricity bill has been used too many times. Continuing with this electricity bill means that we will verify the address by visiting the address in-person..',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
    },
    METER_NO_NOT_FOUND: {
        getDescription: () => 'This meter number does not exist',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Meter Number Not Found',
    },
    EXPIRED_DOCUMENT: {
        modalTitle:'Proof of Address Expired',
        getDescription: () => 'We noticed your proof of address document has expired, it is older than 3 months.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Expired Document',
    },
    OLD_DOCUMENT: {
        modalTitle:'Old Document Detected',
        getDescription: () => 'Proof of address document has expired. Bill is older than 90 days.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Old Document',
    },
    BLACKLISTED_METER_NUMBER: {
        modalTitle:'Blacklisted Meter Number',
        getDescription: () => 'The meter number is blacklisted.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues,
        title: 'Blacklisted',
    },
    UNABLE_TO_VERIFY_DOCUMENT: {
        modalTitle:'Unable to Verify Proof of Address',
        getDescription: () => 'Unable to verify proof of address document due to missing or invalid fields',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    INSUFFICIENT_DATA_FROM_BILL_INFORMATION_PROVIDER: {
        modalTitle:'Insufficient Data',
        getDescription: () => 'We were unable to retrieve information about the meter specified in the uploaded document from the electricity provider',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    ADDRESS_DOCUMENT_HAS_MISSING_OR_INVALID_FIELDS: {
        modalTitle:'Missing Information',
        getDescription: () => 'The uploaded document has missing or invalid fields.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    INVALID_BILLING_DATE_IN_DOCUMENT: {
        modalTitle:'Invalid Bill Date',
        getDescription: () => `Billing date couldn't be read from document.`,
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    INVALID_METER_NUMBER: {
        modalTitle:'Invalid Meter Number',
        getDescription: () => 'The meter number read from the document is invalid.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    VALID_DOCUMENT_ADDRESS_INFO_MISSING: {
        modalTitle:'Invalid Address Info',
        getDescription: () => 'We could not obtain address information for the provided meter from the electricity provider.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    DOCUMENT_HAS_MISSING_OR_INVALID_FIELDS: {
        modalTitle:'Missing Information',
        getDescription: (fields: Array<string>) => fields.length 
        ? `The uploaded document has the following missing or invalid field(s): ${fields.join(', ')}.` 
        : `The uploaded document has missing or invalid fields.`,
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    METER_ADDRESS_GEOCODING_FAILED: {
        modalTitle:'Geocoding Failed',
        getDescription: () => 'We could not obtain address information for the provided meter from the electricity provider.',
        issueCategory: DocumentVerificationErrorCategories.POA_Issues
    },
    NAME_ON_DOCUMENT_NOT_NAME_ASSIGNED_TO_METER: {
        modalTitle:'Name mismatch Detected',
        getDescription: () => 'The name on the uploaded document did not match the name obtained from the electricity provider.',
        issueCategory: DocumentVerificationErrorCategories.Name_Issues,
        title: 'Name Mismatch',
        getConflict: (nameonMeter: string, nameOnDocument: string) => {
            return {
                reference: {
                    title: 'Meter name',
                    details: nameonMeter,
                },
                document: {
                    title: 'Document name',
                    details: nameOnDocument,
                },
            };
        },
    },
    METER_ADDRESS_NOT_DOCUMENT_ADDRESS: {
        modalTitle:'Address Mismatch Detected',
        getDescription: () => 'The address returned for the meter by the electricity provider doesn’t match the address specified in the uploaded document.',
        issueCategory: DocumentVerificationErrorCategories.Address_Issues,
        title: 'Address Mismatch',
        getConflict: (addressonMeter: string, addressOnDocument: string) => {
            return {
                reference: {
                    title: 'Meter address',
                    details: addressonMeter,
                },
                document: {
                    title: 'Document address',
                    details: addressOnDocument,
                },
            };
        },
    },
    METER_ADDRESS_NOT_VERIFICATION_ADDRESS: {
        modalTitle:'Address Mismatch Detected',
        getDescription: () => 'The address returned for the meter by the electricity provider doesn’t match the address being verified by the uploaded document.',
        issueCategory: DocumentVerificationErrorCategories.Address_Issues,
        title: 'Address Mismatch',
        getConflict: (addressonMeter: string, verificationAddress: string) => {
            return {
                reference: {
                    title: 'Meter address',
                    details: addressonMeter,
                },
                document: {
                    title: 'Verification address',
                    details: verificationAddress,
                },
            };
        },
    },
};

export const PhysicalVerificationErrorCodesMap = {
    NOT_AT_ADDRESS: {
        getDescription: () =>
            'To proceed with this step, you need to be at the location you wish to verify. Please ensure you continue when you are at your residential address.',
        title: 'Not at Address',
    },
    NOT_IN_COUNTRY: {
        getDescription: () => 'Kindly confirm your location, as we’ve detected that you’re outside Nigeria.',
        title: 'Not in Country',
    },
    NOT_AT_LOCATION: {
        getDescription: () =>
            'To proceed with this step, you need to be at the location you wish to verify. Please ensure you continue when you are at your residential address.',
        title: 'Not at Location',
    },
};

export const PhysicalVerificationModalContents = {
    VERIFY_LOCATION: {
        modalTitle: 'Are you currently at the address you want to verify?',
        modalDescription: 'Are you currently at the address you want to verify?',
        proceedText: 'Yes, I am',
        cancelText: 'No, I am not',
        showCancelText: true,
    },
    PAUSE_VERIFICATION: {
        modalTitle: 'Continue later',
        modalDescription:
            'To proceed with this step, you need to be at the location you wish to verify. Please ensure you continue when you are at your residential address.',
        proceedText: 'Return to Dashboard',
        showCancelText: false,
    },
    LOCATION_ACCESS_ERROR: {
        modalTitle: 'Unable to get location access',
        modalDescription: 'We’re unable to get access to your location, kindly provide us access so we can verify your residential address',
        proceedText: 'Try Again',
        cancelText: 'Continue Later',
        showCancelText: true,
    },
    INVALID_LOCATION_DATA: {
        modalTitle: 'Unable to get location access',
        modalDescription: `We’re currently unable to validate your location`,
        proceedText: 'Retry',
        cancelText: 'Continue Later',
        showCancelText: true,
    },
    REJECTED: {
        modalTitle: 'Address Verification Rejected',
        modalDescription: 'Verification was rejected for the following reasons',
        proceedText: 'Go to Dashboard',
        cancelText: 'Dismiss',
        showCancelText: false,
    },
    WARNING: {
        modalTitle: 'Address Verification Warning',
        modalDescription: 'Your address verification has the following warnings',
        proceedText: 'Continue',
        cancelText: 'Go to Dashboard',
        showCancelText: true,
    },
    CONTINUE_LATER: {
        modalTitle: 'Continue later',
        modalDescription:
            'To proceed with this step, you need to be at the location you wish to verify. Please ensure you continue when you are at your residential address.',
        proceedText: 'Return to Dashboard',
        showCancelText: false,
    },
    REINITIATE_ADDRESS_COLLECTION: {
        modalTitle: 'Please upload new proof of address',
        modalDescription:
            'Your current location seems to be very different from the address you provided for verification. To proceed, provide a proof of address that matches this address.',
        proceedText: 'Re-initiate Address Collection',
        cancelText: 'Edit Current Location',
        showCancelText: true,
    },
    CREATED: {
        modalTitle: 'Physical Address Verification Ongoing',
        modalDescription:
            'A Moniepoint address verification officer will be around to verify your address, within 3 business days. You will be notified as soon as the verification process is completed.',
        proceedText: 'Continue',
        showCancelText: false,
    },
    ACCEPTED: {
        modalTitle: 'A Moniepoint agent will verify your address.',
        modalDescription: 'You will be notified as soon as the verification process is completed',
        proceedText: 'Continue',
        showCancelText: false,
    },
    ADDRESS_NOT_FOUND: {
        modalTitle: 'Physical Verification Address not Found',
        modalDescription: 'Kindly re-initiate Address Collection',
        proceedText: 'Re-Initiate Address Collection',
        cancelText: 'Try Again Later',
        showCancelText: true,
    },
    VERIFICATION_NOT_FOUND: {
        modalTitle: 'Verification Not Found',
        modalDescription: 'Unable to Carry out Verification for Current User',
        proceedText: 'Try Again Later',
        showCancelText: false,
    },
    STRATEGY_UNSUPPORTED: {
        modalTitle: 'Unsupported Strategy',
        modalDescription: 'The Selected Strategy is Unsupported',
        proceedText: 'Restart Proccess',
        cancelText: 'Try Again Later',
        showCancelText: true,
    },
    STRATEGY_NOT_ALLOWED: {
        modalTitle: 'Strategy Not Allowed',
        modalDescription: 'Phsycial Verification not Allowed for Current User',
        proceedText: 'Try Again Later',
        showCancelText: false,
    },
};

export interface DocumentVerificationModalContent {
    modalDescription: string;
    proceedText: string;
    cancelText: string;
}

export type SavedUserTokenData = {
    email: string;
    username: string;
    phone: string;
    expires_in: number;
    firstName: string;
    hasAgents: boolean;
    hasMultipleBusiness: boolean;
    hasUserPin: boolean;
    lastName: string;
    refreshTokenExpiresIn: number;
    refresh_token: string;
    roles: string[];
    shouldCompleteKyc: boolean;
    shouldCompleteKycBeforeSoftOnboarding: boolean;
    shouldCompleteSelfOnboardingKyc: boolean;
    userId: number;
    userType: string;
    ussdChannelEnabled: boolean;
    zen_desk_access_token: string;
};

export const enum OnboardingKycLevel3MixpanelEvents {
    get_kycl3_face_verification_status_initiated = 'get_kycl3_face_verification_status_initiated',
    get_kycl3_face_verification_status_success = 'get_kycl3_face_verification_status_success',
    get_kycl3_face_verification_status_failed = 'get_kycl3_face_verification_status_failed',
    submit_kycl3_face_verification_job_initiated = 'submit_kycl3_face_verification_job_initiated',
    submit_kycl3_face_verification_job_success = 'submit_kycl3_face_verification_job_success',
    submit_kycl3_face_verification_job_failed = 'submit_kycl3_face_verification_job_failed',
    kycl3_face_verification_required_initiated = 'kycl3_face_verification_required_initiated',
    kycl3_face_verification_required_success = 'kycl3_face_verification_required_success',
    kycl3_face_verification_required_failed = 'kycl3_face_verification_required_failed',
    start_kycl3_face_verification_initiated = 'start_kycl3_face_verification_initiated',
    start_kycl3_face_verification_success = 'start_kycl3_face_verification_success',
    start_kycl3_face_verification_failed = 'start_kycl3_face_verification_failed',
    update_kycl3_face_verification_status_initiated = 'update_kycl3_face_verification_status_initiated',
    update_kycl3_face_verification_status_success = 'update_kycl3_face_verification_status_success',
    update_kycl3_face_verification_status_failed = 'update_kycl3_face_verification_status_failed',
}

export const NEW_BO_KYC_LVL3_ACCOUNT_NAME_FORMAT = 'Your Account Name is your “Personal Name"';

export interface AdditionalBusinessInformation {
    businessTypeList: BusinessTypeList[];
    hasSubmittedAdditionalBusinessInfo: boolean;
}

export interface BusinessInformationBusinessTypeList{
    id: number,
    name: string,
    code: string,
    description: string,
    businessCategoryName: string,
    businessCategoryId: number,
    default?: boolean
}

export interface BusinessTypeList {
    businessSubCategory: BusinessSubCategory;
    businessCategory: BusinessCategory;
}

export interface BusinessSubCategory {
    id: number;
    status: string;
    createdOn: string;
    lastModifiedOn: string;
    name: string;
    code: string;
    description: string;
    businessCategory: BusinessCategory;
    scuml: boolean;
    operatingLicense: boolean;
    default: boolean;
    iconLink?: string;
}

export interface BusinessCategory {
    id: number;
    status: string;
    createdOn: string;
    lastModifiedOn: string;
    name: string;
    description: string;
    iconLink: string;
}

export interface PhysicalVerificationDryRunPayload {
    strategy?: PhysicalVerificationStrategies;
    currentLocation: CurrentLocation;
    metadata?: {
        '@type': PhysicalVerificationMetaDataTypes;
        'reportedCurrentLocation'?: CurrentLocation;
    };
}

export interface PhysicalVerificationDryRunResponse {
    data: {
        address: AddressV2Details;
        appliedStrategyResults: {
            strategy: PhysicalVerificationStrategies;
            errors?: ErrorMessageDetail[];
            warnings?: ErrorMessageDetail[];
        };
        eligibleStrategies: PhysicalVerificationStrategies[];
    };
    metadata: {
        errors?: ErrorMessageDetail[];
        resultCode: PhysicalVerificationResultCodes;
    };
}

export interface PhysicalVerificationStrategyResponse {
    data: {
        address: AddressV2Details;
        strategy: PhysicalVerificationStrategies;
        eligibleStrategies: PhysicalVerificationStrategies[];
    };
    metadata: {
        errors?: ErrorMessageDetail[];
        resultCode: PhysicalVerificationResultCodes;
    };
}

export interface PhysicalVerificationPayload {
    strategy: PhysicalVerificationStrategies;
    currentLocation: CurrentLocation;
    metadata: PhysicalVerificationMetaData;
}

export interface PhysicalVerificationMetaData {
    '@type': string;
    'reportedCurrentLocation'?: CurrentLocation;
    'initiatorUserReference': string;
    'area': string;
    'majorLandmark': string;
    'colorOfHouse': string;
    'colorOfGate': string;
    'buildingType': string;
    'notes': string;
    'seconderName': string;
    'seconderRelationShip': string;
    'nickName': string;
    'assigneeEmail'?:string;
}

export interface PhysicalVerificationResponse {
    data: {
        address: AddressV2Details;
        verification: {
            strategy: PhysicalVerificationStrategies;
            initiationMetadata: string;
            status: string;
            statusMetadata: string;
            comment: string;
            initiationLatitude: number;
            initiationLongitude: number;
            reference: string;
            version: string;
            estimatedCompletionDate: string;
            completedAt: string;
        };
        eligibleStrategies: PhysicalVerificationStrategies[];
    };
    metadata: {
        errors?: ErrorMessageDetail[];
        resultCode: PhysicalVerificationResultCodes;
    };
}

export enum PhysicalVerificationStrategies {
    OKHI_DIGITAL_VERIFICATION = 'OKHI_DIGITAL_VERIFICATION',
    FVS_VERIFICATION = 'FVS_VERIFICATION',
}

export enum PhysicalVerificationMetaDataTypes {
    FVS_METADATA = 'FVS_METADATA',
}

export interface NavigationMetaData {
    addressDetails?: AddressGeolocation;
}

export const KycDocumentIconMap: Record<string, string> = {
    ELECTRICITY_BILL: 'assets/images/svgs/electricity-bill-icon.svg',
    WATER_BILL: 'assets/images/svgs/default-bill-icon.svg',
    WASTE_MANAGEMENT_BILL: 'assets/images/svgs/default-bill-icon.svg',
    DRIVER_LICENSE: 'assets/images/svgs/drivers-license-icon.svg',
    BANK_STATEMENT: 'assets/images/svgs/bank-statement-icon.svg',
    SOLICITOR_LETTER: 'assets/images/svgs/solicitor-letter-icon.svg',
    TENANCY_AGREEMENT: 'assets/images/svgs/tenancy-agreement-icon.svg',
    VOTERS_CARD: 'assets/images/svgs/voters-card-icon.svg',
};

export const KYC_DEFAULT_DOCUMENT_ICON = 'assets/images/svgs/default-bill-icon.svg';

export interface DocumentUploadRequirement {
    icon: string,
    text: string
}

export const DocumentUploadRequirements  = (displayAddress: string) : Array<DocumentUploadRequirement> => [
    {
      icon: 'assets/images/svgs/location-pin-2.svg',
      text: `Your address matches this - <span class="text-black font-semibold">${displayAddress}</span>`
    },
    {
      icon: 'assets/images/svgs/solicitor-letter-icon.svg',
      text: `Your proof of address is <span class="text-black font-semibold">valid</span> and <span class="text-black font-semibold">not expired</span>`
    },
    {
      icon: 'assets/images/svgs/id-card-icon.svg',
      text: `Your <span class="text-black font-semibold">name</span>, <span class="text-black font-semibold">photo</span>, and <span class="text-black font-semibold">residential address</span> are clearly displayed`
    },
    {
      icon: 'assets/images/svgs/blurry-document-icon.svg',
      text: `Your document must not be blurry`
    }
  ];
